// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:57:41.371Z
// Property: Pebblebrook Apartment Homes (ID: 6767906449167606)
// Collections: 20 amenities, 4 floorplans (live), 40 photos, 76 POIs, 2 reviews, 4 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167606",
  "property_external_id": "1124181",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/pebblebrook-apartment-homes-overland-park-ks/xxmrbhm/",
  "property_google_business_url": "https://www.google.com/maps/place/Pebblebrook+Apartment+Homes/@38.9570407,-94.6748613,769m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0eb47eaad3321:0x81ba2e227946ec8f!8m2!3d38.9570407!4d-94.6748613!16s%2Fg%2F1tgcmtlr?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124181 p1099133",
  "property_status": null,
  "property_slug": "pebblebrook-apartment-homes",
  "property_name": "Pebblebrook Apartment Homes",
  "property_website_url": "https://www.pebblebrookapts.com/",
  "property_domain": "https://www.pebblebrookapts.com/",
  "property_address": "7700 W 95th St",
  "property_full_address": "7700 W 95th St, Overland Park, KS 66212",
  "property_address_1": "7700 W 95th St",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66212",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Pebblebrook",
  "property_address_latitude": "38.958526",
  "property_address_longitude": "-94.6737782",
  "property_email": "rentcafe.pb@pricekc.com",
  "property_phone": "(913) 513-4103",
  "property_call_tracking_phone": "913-513-4103",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Settle into a greener corner of Central Overland Park.</strong> Pebblebrook Apartment Homes pairs comfortable one- and two-bedroom layouts with in-home laundry, generous storage, and relaxed outdoor spaces—then makes it easy to see what fits next.</p>",
  "property_long_description": "<p>Pebblebrook Apartment Homes is an apartment community at 7700 W. 95th Street in Overland Park, KS, set around two duck ponds with fountains and a nature trail that winds through the grounds. Just off one of Overland Park’s busiest corridors, it feels like a quiet park the moment you pull in. The community is managed by Price Brothers Management, a Kansas City family-owned company since 1922.</p><p>Mornings start with a walk around the ponds, afternoons are for the pool, and evenings bring neighbors out to the charcoal grills and picnic areas. Every one- and two-bedroom apartment has an in-unit washer and dryer, large closets with shoe racks, and ceiling fans, and select homes add a wood-burning fireplace for cooler Kansas City nights. The fitness center, resident clubhouse, and rentable carports round out the community.</p><p>Browse our <a href=\"/floor-plans\">floor plans</a>, explore our <a href=\"/amenities\">amenities</a>, or <a href=\"/contact-us\">contact our leasing team</a> to get started.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-84c4-765a-b78e-8021a251431e.webp",
  "property_featured_image_media": {
    "alt_text": "Gym with cardio equipment, weight machines, free weights, and ceiling fans.",
    "public_id": "01a0102f-84c4-765a-b78e-8021a251431e",
    "storage_key": "property/6767906449167606/01a0102f-84c4-765a-b78e-8021a251431e.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "267",
  "property_year_built": "1985",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.3820224719101",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://pebblebrookapts.securecafeapplicant.com/onlineleasing/content3/access/pebblebrook0/floorplans",
  "property_resident_portal_url": "https://pebblebrookapts.securecafenet.com/residentservices/pebblebrook0/userlogin",
  "property_apply_now_url": "https://pebblebrookapts.securecafeapplicant.com/onlineleasing/content3/access/pebblebrook0/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-5398-76a7-bbcc-058204bc755b.webp",
  "property_primary_logo_media": {
    "alt_text": "Pebblebrook Apartment Homes logo",
    "public_id": "019fc980-5398-76a7-bbcc-058204bc755b",
    "storage_key": "property/6767906449167606/019fc980-5398-76a7-bbcc-058204bc755b.webp",
    "width": 1275,
    "height": 300
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-0475-7702-bc8c-fe1a4972840d.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc982-0475-7702-bc8c-fe1a4972840d",
    "storage_key": "property/6767906449167606/019fc982-0475-7702-bc8c-fe1a4972840d.webp",
    "width": 1275,
    "height": 300
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc981-f416-738b-b802-6d01d7763785.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc981-f416-738b-b802-6d01d7763785",
    "storage_key": "property/6767906449167606/019fc981-f416-738b-b802-6d01d7763785.webp",
    "width": 1275,
    "height": 300
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002E5D",
  "property_secondary_color": "#034638",
  "property_font_color": null,
  "property_color_4": "#CC8A00",
  "property_color_3": "#3C1053",
  "property_color_5": "#CF5C36",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "500 - 900",
  "property_sqft_min": "500",
  "property_sqft_max": "900",
  "property_price_range": "1159 - 5664",
  "property_price_min": "1159",
  "property_price_max": "5664",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/PebblebrookApts",
  "property_instagram_url": "https://www.instagram.com/pebblebrookapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJITOt6kfrwIcRj-xGeSIuuoE",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Pebblebrook Apartment Homes",
  "property_home_romance_title": "Embrace Life in Your Charming New Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Everyday amenities with room to unwind.</strong> Start with a workout, cool off by the shimmering pool, or take a quiet stroll along the nature trail and two fountain ponds. Landscaped courtyards, picnic areas, charcoal grills, a clubhouse, and a lounge add easy places to relax outside your door, while in-home washers and dryers, generous closets, and well-equipped kitchens keep daily routines simple.</p>",
  "property_home_floorplans_blurb": "<p><strong>Room to choose, details to love.</strong> Explore one-bedroom layouts with smooth everyday flow or two-bedroom, two-bath homes with added separation and storage. Pebblebrook floor plans pair practical comforts like in-home washer and dryer sets, dishwashers, electric ranges, large closets with shoe racks, and select private outdoor space—with available fireplaces or stainless appliances adding extra character.</p>",
  "property_home_gallery_blurb": "<p><strong>See Pebblebrook in full color.</strong> Preview leafy courtyards, fountain-touched duck ponds, and a poolside sundeck with a calm, tucked-away feel in Overland Park. Inside the gallery, explore bright living spaces, easy kitchens with stainless finishes in select homes, private patios or balconies, in-home laundry, generous closets, and warm touches like wood-burning fireplaces in select layouts.</p>",
  "property_home_neighborhood_blurb": "<p>Pebblebrook sits on W. 95th Street, with restaurants, shopping, and groceries minutes away and I-435 and I-35 close by for commutes. When the day is done, the ponds and nature trail are waiting at home. Visit our <a href=\"/neighborhood\">Neighborhood page</a> to see what’s nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents keep coming back to Pebblebrook.</strong> Reviews often highlight the calm Overland Park setting, friendly service, and maintenance requests handled quickly and carefully—sometimes within 24 hours. Everyday perks like in-unit laundry, functional kitchen space, convenient community areas, and welcoming resident events add to the comfort. Read the reviews to see why service and quiet convenience stand out.</p>",
  "property_neighborhood_blurb": "<p>Pebblebrook Apartment Homes is located at 7700 W. 95th Street in Overland Park, KS, along the 95th Street retail and dining corridor. I-435 and I-35 are close by for commutes across the Kansas City metro, and the T-Mobile campus is a short drive away.</p><p>Looking for a place to eat near Pebblebrook? Discourse Brewing is about a 13-minute walk from the community. Our team also recommends Jack Stack Barbecue for Kansas City barbecue, KIWAMI Ramen &amp; Sushi, Sickies Garage Burgers &amp; Brews, and Longhorn Steakhouse. Stop by Topsy’s for popcorn and a sweet treat.</p><p>Back home, Pebblebrook’s duck ponds and nature trail make it easy to get outside without going far.</p><p>Explore the neighborhood map to see what else is nearby.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Pebblebrook Apartment Homes is one of the only Overland Park apartment communities with its own duck ponds and nature trail. Two ponds with fountains sit at the center of the property, and the trail winds through the landscaped grounds, so a peaceful walk is always right outside your door.</p><p>Residents also have a swimming pool, a fitness center, a resident clubhouse, and charcoal grills with picnic areas for cookouts with neighbors. Rentable carports and storage spaces add everyday convenience, and 24-hour emergency maintenance and flexible rent payment options keep things simple.</p><p>Inside, every apartment has an in-unit washer and dryer, large closets with shoe racks, a kitchen with a dishwasher and electric range, ceiling fans, and window treatments. Select homes include a wood-burning fireplace. Pebblebrook is a smoke-free, pet-friendly community.</p><p>Explore the full list of amenities above.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Pebblebrook home?</strong> Start your application online for a one- or two-bedroom apartment in Central Overland Park, with everyday comforts like in-home laundry, well-equipped kitchens, generous closets, and relaxing green spaces just outside your door.</p>",
  "property_contactus_blurb": "<p>Have a question about Pebblebrook Apartment Homes? Connect with our leasing team for information about apartment availability, <a href=\"/floor-plans\">floor plans</a>, <a href=\"/amenities\">amenities</a>, leasing terms, or upcoming <a href=\"/schedule-a-tour\">tours</a>.</p><p>Visit us at 7700 W. 95th Street in Overland Park, Kansas, give us a call at <a href=\"tel:+19135134103\">(913) 513-4103</a>, or complete the contact form above. Our office is open Monday through Friday from 9:30 AM to 5:30 PM and Saturday from 10 AM to 5 PM. Self-guided tours are also available by appointment. We look forward to helping you find your home at Pebblebrook Apartment Homes.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Pebblebrook Apartment Homes?</strong> Find quick answers about our one- and two-bedroom apartments, everyday comforts, community features, leasing details, and what living in Central Overland Park can look like. If you need anything else, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p>Pebblebrook Apartment Homes offers three floor plans in Overland Park, KS. The Aspen one-bedroom has 500 square feet, the Spruce one-bedroom has 700 square feet, and the Birch two-bedroom, two-bath apartment has 900 square feet.</p><p>Every Pebblebrook apartment includes an in-unit washer and dryer, large closets with shoe racks, a dishwasher, an electric range, ceiling fans, and window treatments. Select homes add a wood-burning fireplace.</p><p>Browse available floor plans above, or <a href=\"/contact-us\">contact our leasing team</a> to <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_gallery_blurb": "<p>Browse Pebblebrook Apartment Homes photos to see the duck ponds and fountains, the nature trail through the landscaped grounds, the swimming pool, the fitness center, and the grill and picnic areas. Inside, see kitchens with dishwashers and electric ranges, closets with shoe racks, in-unit washers and dryers, and select homes with wood-burning fireplaces.</p><p>Ready to see more? <a href=\"/schedule-a-tour\">Schedule a tour</a> of Pebblebrook Apartment Homes.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Pebblebrook on the map.</strong> See available one- and two-bedroom apartments in a greener Central Overland Park setting, then zoom out to discover nearby shopping, transit, and routes connecting you to Downtown Overland Park and the Kansas City metro.</p>",
  "property_pets_blurb": "<p>Pebblebrook Apartment Homes welcomes cats and dogs, making our community one of the pet-friendly apartment options in Overland Park, Kansas. The surrounding nature trail, parks, and green spaces near our W. 95th Street location give pet owners convenient options for outdoor time.</p><p>Up to two pets are permitted per apartment home. Monthly pet rent is $35 per pet, with a $350 non-refundable fee per pet. Breed restrictions apply. Assistance animals are not considered pets and are not subject to pet fees or restrictions. As a resident of Pebblebrook Apartment Homes, your pets are also members of the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a>, which provides special offers and discounts at local pet-related businesses.</p><p><a href=\"/contact-us\">Contact our leasing team</a> at Pebblebrook Apartment Homes for complete pet guidelines, breed restriction details, and current policy information.</p>",
  "property_referafriend_blurb": "<p><strong>Share your greener corner of Central Overland Park.</strong> Invite friends to discover Pebblebrook Apartment Homes, where comfortable one- and two-bedroom layouts, in-home conveniences, relaxed community spaces, and duck ponds with fountains make everyday living feel simple, useful, and connected.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access made simple.</strong><br>Log in to pay rent, submit maintenance requests, and manage your Pebblebrook account—so everyday comforts like in-home laundry, well-equipped kitchens, and relaxed community spaces stay easy to enjoy.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Pebblebrook.</strong> As you browse the reviews, you’ll notice a few themes come up again and again: a calm setting, friendly service, and maintenance requests handled quickly and carefully. Residents praise the team for being warm, responsive, and thorough—one reviewer summed it up simply: “People come back to Pebblebrook.”</p><p>You’ll also hear appreciation for everyday conveniences like in-unit laundry, useful kitchen space, easy access to community areas, and resident events that make the property feel welcoming. From quick fixes completed within 24 hours to a location that stays surprisingly quiet, the reviews reflect a community where comfort and service stand out.</p>",
  "property_created_at": "1785791966101",
  "property_scheduletour_blurb": "<p>See Pebblebrook Apartment Homes for yourself. Schedule a guided or self-guided tour to explore available apartment homes and community spaces in Overland Park, Kansas.</p><p>During your visit, take a closer look at our one- and two-bedroom apartment interiors, community amenities including the swimming pool, fitness center, nature trail, and duck ponds, and the overall setting that makes Pebblebrook Apartment Homes a great place to live. Our leasing team will be available to answer any questions you have about availability, pricing, and lease terms.</p><p>Choose a tour option and time above to plan your visit to Pebblebrook Apartment Homes.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture a greener corner of Central Overland Park with comfortable one- and two-bedroom apartments, in-home laundry, well-equipped kitchens, generous closets, and relaxed spaces like landscaped courtyards, a pool, and duck ponds with fountains.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Pebblebrook Apartment Homes",
  "property_seo_title_home": "Pebblebrook Apartment Homes | Overland Park, KS 66212",
  "property_seo_description_home": "1 & 2 bedroom apartments in Overland Park, KS. Pool, fitness center, nature trail & duck ponds. Near W. 95th St, restaurants & easy freeway access.",
  "property_seo_title_floorplans": "1 & 2 Bedroom Floor Plans | Pebblebrook Overland Park",
  "property_seo_description_floorplans": "Browse 1 & 2 bedroom floor plans at Pebblebrook Apartment Homes in Overland Park, KS. In-home washer/dryer, large closets, dishwasher & ceiling fans.",
  "property_seo_title_amenities": "Pool, Fitness Center & Nature Trail | Overland Park KS",
  "property_seo_description_amenities": "Pebblebrook Apartment Homes offers a pool, fitness center, nature trail, duck ponds, charcoal grills, clubhouse, carports & storage in Overland Park, KS.",
  "property_seo_title_gallery": "Apartment Photos | Pebblebrook Homes Overland Park KS",
  "property_seo_description_gallery": "Browse photos of Pebblebrook Apartment Homes in Overland Park, KS — pool, nature trail, duck ponds, fitness center & community spaces. Picture yourself here!",
  "property_seo_title_virtualtours": "Virtual Tours | Pebblebrook Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Step into Pebblebrook Apartment Homes in Overland Park, KS! Take a virtual tour of our stylish one and two-bedroom apartments today—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Pebblebrook Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Pebblebrook Apartment Homes in Overland Park, KS! Use our map for layouts, pricing, and upgrades.",
  "property_seo_title_neighborhood": "Overland Park KS Neighborhood Guide | Apartments 95th",
  "property_seo_description_neighborhood": "Pebblebrook Apartment Homes is nestled near restaurants, metro stations, walking plaza & gardens on W. 95th Street in Overland Park, KS. Easy freeway access.",
  "property_seo_title_contact": "Contact Pebblebrook Apartment Homes | Overland Park",
  "property_seo_description_contact": "Have questions about our apartments in Overland Park, KS? Reach the Pebblebrook Apartment Homes team at 7700 W 95th St by phone or online. We'd love to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Overland Park, KS",
  "property_seo_description_faqs": "Unravel your lifestyle at Pebblebrook Apartments in Overland Park, KS. Visit our FAQs to learn about our spacious layouts and amenities!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Overland Park, KS",
  "property_seo_description_reviews": "Join our vibrant community at Pebblebrook Apartment Homes in Overland Park, KS. Check out glowing reviews from residents about life, amenities, and more!",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Find your perfect sanctuary at Pebblebrook Apartment Homes in Overland Park, KS. Enjoy spacious layouts, vibrant amenities, and a smoke-free lifestyle!",
  "property_seo_title_residentaccess": "Resident Access | Pebblebrook Apartment Homes",
  "property_seo_description_residentaccess": "Login to the Pebblebrook resident portal for seamless rent payments, hassle-free maintenance requests, and exclusive community updates in Overland Park, KS!",
  "property_seo_title_referafriend": "Refer A Friend | Pebblebrook Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Pebblebrook Apartment Homes in Overland Park, KS! Great friends make great neighbors—share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Pebblebrook Homes Overland Park KS",
  "property_seo_description_scheduletour": "Ready to see Pebblebrook Apartment Homes in person? Schedule an in-person or virtual tour of our 1 & 2 bedroom apartments in Overland Park, KS today!",
  "property_seo_title_privacy": "Privacy Policy | Pebblebrook Apartment Homes",
  "property_seo_description_privacy": "Protecting your peace of mind at Pebblebrook Apartment Homes in Overland Park, KS. Your privacy is our priority—view our policy for more details.",
  "property_seo_title_accessibility": "Website Accessibility | Pebblebrook Apartment Homes",
  "property_seo_description_accessibility": "At Pebblebrook Apartment Homes in Overland Park, we prioritize digital inclusion, ensuring everyone can easily access our information and services.",
  "property_seo_title_sitemap": "Sitemap | Pebblebrook Apartment Homes",
  "property_seo_description_sitemap": "Uncover the layout of Pebblebrook Apartment Homes in Overland Park, KS. Navigate your perfect living space with our comprehensive sitemap today!",
  "property_seo_title_thankyou": "Thank You | Pebblebrook Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out to Pebblebrook Apartment Homes in Overland Park, KS! Our team will be in touch soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet-Friendly Apartments | Pebblebrook Homes KS 66212",
  "property_seo_description_pets": "Pebblebrook Apartment Homes welcomes cats & dogs in Overland Park, KS. Up to 2 pets per home. Enjoy pet-friendly living & the Price Brothers Pet Royalty Club.",
  "property_updated_at": "1793742980914",
  "amenities": [
    {
      "id": "ec_3377eb431a688d5da526841d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989800",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-9d2a-73a7-bc54-697907ff81d3.webp",
      "amenity_image_media": {
        "alt_text": "Brick building with a covered entryway, surrounded by lush landscaping and a paved walkway.",
        "public_id": "01a0102f-9d2a-73a7-bc54-697907ff81d3",
        "storage_key": "property/6767906449167606/01a0102f-9d2a-73a7-bc54-697907ff81d3.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A house with a grey roof and a brown brick exterior is surrounded by a garden with a concrete walkway.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbd6e66bbcac818e3c81c455",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989804",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-9af3-71b0-92e0-a890e7bf5a01.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and trees.",
        "public_id": "01a0102f-9af3-71b0-92e0-a890e7bf5a01",
        "storage_key": "property/6767906449167606/01a0102f-9af3-71b0-92e0-a890e7bf5a01.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A large swimming pool surrounded by trees and lounge chairs.,A pool surrounded by trees and lounge chairs.,A pool with a small building behind it.,A poolside table and chairs are arranged on a patio.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6bd0b0f6580270fa8ae1982",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989805",
      "title": "State-Of-The-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-9b9c-75ba-9b63-75389d0fa91c.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with cardio equipment, weight machines, dumbbells, and benches.",
        "public_id": "01a0102f-9b9c-75ba-9b63-75389d0fa91c",
        "storage_key": "property/6767906449167606/01a0102f-9b9c-75ba-9b63-75389d0fa91c.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A spacious home gym with a variety of exercise equipment.,A home gym with a brick wall and a ceiling fan.,A home gym with treadmills and elliptical machines.,A home gym with a treadmill, weights, and exercise equipment.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c0916a96ab49259e7ff0d39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989796",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd8e66f15ee686a30d0a8135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989807",
      "title": "Surrounding Nature Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34239dff2fe2d971eb1bc8e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989808",
      "title": "Two Scenic Duck Ponds with Fountains",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-9f2c-73bd-b03c-162948dcfcc0.webp",
      "amenity_image_media": {
        "alt_text": "Apartment buildings with balconies overlooking a pond with a fountain.",
        "public_id": "01a0102f-9f2c-73bd-b03c-162948dcfcc0",
        "storage_key": "property/6767906449167606/01a0102f-9f2c-73bd-b03c-162948dcfcc0.webp",
        "width": 719,
        "height": 479
      },
      "amenity_image_alt_text": "Fountains In Lake at Pebblebrook, Overland Park, KS, 66212",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b89cdeeda54d19f17ef4971",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989801",
      "title": "Easy Access to Freeways and Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfed82f95aa9554bf4acb001",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989797",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cbec450f68bc7662e511491c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989798",
      "title": "Carports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-9ba0-7401-bbd8-996c27379fb4.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking spaces with cars parked in them, surrounded by trees and grass.",
        "public_id": "01a0102f-9ba0-7401-bbd8-996c27379fb4",
        "storage_key": "property/6767906449167606/01a0102f-9ba0-7401-bbd8-996c27379fb4.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A covered parking area with a few cars parked.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0825108d6ea31fdf862a71a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989799",
      "title": "Charcoal Grills",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-aa2e-7697-91a5-5199e0e3d4ff.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor picnic area with tables and grill, fenced courtyard, and brick building exterior.",
        "public_id": "01a0102f-aa2e-7697-91a5-5199e0e3d4ff",
        "storage_key": "property/6767906449167606/01a0102f-aa2e-7697-91a5-5199e0e3d4ff.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A house with a picnic table in front of it.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ad8c8224dc8bde1e35e6dfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989806",
      "title": "Storage Spaces",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_748613903b1e4269fb61db6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "120549877",
      "title": "Smoke Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_944870285c61c3d25ec88a14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "122755387",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_261995cab2d0cf54a1b094bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989819",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-ac31-719c-8bc1-3ab535a70739.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white countertops, wooden cabinets, stainless steel sink, dishwasher, and refrigerator.",
        "public_id": "01a0102f-ac31-719c-8bc1-3ab535a70739",
        "storage_key": "property/6767906449167606/01a0102f-ac31-719c-8bc1-3ab535a70739.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A kitchen with a white refrigerator and brown cabinets.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa9df232168766abceb56317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989822",
      "title": "In-Home Washer & Dryer Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-abb8-720b-815b-64ad75dcedd6.webp",
      "amenity_image_media": {
        "alt_text": "Stacked washer and dryer next to a white refrigerator in a kitchen.",
        "public_id": "01a0102f-abb8-720b-815b-64ad75dcedd6",
        "storage_key": "property/6767906449167606/01a0102f-abb8-720b-815b-64ad75dcedd6.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A white refrigerator stands in a kitchen next to a coffee machine.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b325081205cb31301a92d6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989818",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-adfc-74c8-ab96-bc3e654471d6.webp",
      "amenity_image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, green accents, and decorative wall art.",
        "public_id": "01a0102f-adfc-74c8-ab96-bc3e654471d6",
        "storage_key": "property/6767906449167606/01a0102f-adfc-74c8-ab96-bc3e654471d6.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A bedroom with a large bed and a ceiling fan.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64a48dc1e576daeb6bbe73d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989820",
      "title": "Electric Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-b282-7458-b8c7-8079c06c23cf.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with wooden cabinets, white countertops, double sink, and a dining area with a round table and green chairs.",
        "public_id": "01a0102f-b282-7458-b8c7-8079c06c23cf",
        "storage_key": "property/6767906449167606/01a0102f-b282-7458-b8c7-8079c06c23cf.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A kitchen with a stove, sink, and chairs.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e23a4186cb356a56f740d9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989821",
      "title": "Large Closets with Shoe Racks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-b6a3-76fd-8cc3-90fb69d2b220.webp",
      "amenity_image_media": {
        "alt_text": "Spacious walk-in closet with organized clothing and shoes.",
        "public_id": "01a0102f-b6a3-76fd-8cc3-90fb69d2b220",
        "storage_key": "property/6767906449167606/01a0102f-b6a3-76fd-8cc3-90fb69d2b220.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A white closet with clothes hanging and shoes on the floor.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_86de01ae0d844ee4151f00c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989823",
      "title": "Window Treatments",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-b942-72eb-afaf-5371b52c9a8d.webp",
      "amenity_image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, green comforter, and a modern dresser.",
        "public_id": "01a0102f-b942-72eb-afaf-5371b52c9a8d",
        "storage_key": "property/6767906449167606/01a0102f-b942-72eb-afaf-5371b52c9a8d.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A bedroom with a bed, nightstands, and a painting on the wall.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ba5cdfadf9bc62cefab2f244",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "external_id": "87989824",
      "title": "Wood Burning Fireplace*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-b9cc-70c9-865f-fc8df5a4f006.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a green sofa, armchair, coffee table, and fireplace.",
        "public_id": "01a0102f-b9cc-70c9-865f-fc8df5a4f006",
        "storage_key": "property/6767906449167606/01a0102f-b9cc-70c9-865f-fc8df5a4f006.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A living room with a green couch and a fireplace.,A modern living room with a fireplace and a television.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_f5d19aef11efa354521a20f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-84c4-765a-b78e-8021a251431e.webp",
      "image_media": {
        "alt_text": "Gym with cardio equipment, weight machines, free weights, and ceiling fans.",
        "public_id": "01a0102f-84c4-765a-b78e-8021a251431e",
        "storage_key": "property/6767906449167606/01a0102f-84c4-765a-b78e-8021a251431e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active and healthy in our fully-equipped fitness center, featuring cardio machines, strength training equipment, and free weights. Enjoy your workout with a view of the pool.",
      "link": "false",
      "alt_text": "Gym with cardio equipment, weight machines, free weights, and ceiling fans.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Fitness-Center_Angle-3_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_c39fd2d4bb90330bd1bad6f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-d05f-72e9-a61c-92274908f24b.webp",
      "image_media": {
        "alt_text": "Living room with plush green sectional sofa, modern coffee table, and abstract art.",
        "public_id": "01a0102f-d05f-72e9-a61c-92274908f24b",
        "storage_key": "property/6767906449167606/01a0102f-d05f-72e9-a61c-92274908f24b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into this inviting living area featuring a comfortable sectional sofa, a stylish coffee table, and vibrant wall art, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with plush green sectional sofa, modern coffee table, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Living-Room_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_4f05d5eef2d3935635ccb107",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-cebd-7595-a8eb-890f213320d8.webp",
      "image_media": {
        "alt_text": "A cozy bedroom featuring a large bed with gray bedding and yellow accent pillows, nightstands with lamps, and a ceiling fan.",
        "public_id": "01a0102f-cebd-7595-a8eb-890f213320d8",
        "storage_key": "property/6767906449167606/01a0102f-cebd-7595-a8eb-890f213320d8.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom. Featuring a plush bed with elegant linens and soft accent pillows, complemented by stylish nightstands and a ceiling fan for year-round comfort.",
      "link": "false",
      "alt_text": "A cozy bedroom featuring a large bed with gray bedding and yellow accent pillows, nightstands with lamps, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Model-Apartment_Bedroom_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_428db04446eb2dd456432521",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-d154-77a9-89c3-a93ce4fd833f.webp",
      "image_media": {
        "alt_text": "Apartment buildings with manicured lawns and mature trees.",
        "public_id": "01a0102f-d154-77a9-89c3-a93ce4fd833f",
        "storage_key": "property/6767906449167606/01a0102f-d154-77a9-89c3-a93ce4fd833f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Experience serene living surrounded by lush greenery and well-maintained grounds. Our community offers a peaceful retreat with beautiful landscaping.",
      "link": "false",
      "alt_text": "Apartment buildings with manicured lawns and mature trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Residential-Buildings_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_45e4fe00ab2a8a0a3abd268e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-d518-77f4-97b0-d234e4ac1633.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, white countertops, stainless steel sink, and a white refrigerator.",
        "public_id": "01a0102f-d518-77f4-97b0-d234e4ac1633",
        "storage_key": "property/6767906449167606/01a0102f-d518-77f4-97b0-d234e4ac1633.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A view of the kitchen, featuring ample storage with dark wood cabinets, dual basin stainless steel sink, and white countertops. Includes a refrigerator, dishwasher, and stove.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, white countertops, stainless steel sink, and a white refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Model-Apartment_Kitchen_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_32226689e16f284ad754c32c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-d806-718b-a47f-9158fa63a55f.webp",
      "image_media": {
        "alt_text": "Covered parking spots with cars parked in them.",
        "public_id": "01a0102f-d806-718b-a47f-9158fa63a55f",
        "storage_key": "property/6767906449167606/01a0102f-d806-718b-a47f-9158fa63a55f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Protect your vehicle from the elements with convenient covered parking available for residents.",
      "link": "false",
      "alt_text": "Covered parking spots with cars parked in them.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Carports_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_ef4b677b350ce19b39c22879",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-f655-70ed-82a0-f5dccdba75ee.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables at a multifamily property.",
        "public_id": "01a0102f-f655-70ed-82a0-f5dccdba75ee",
        "storage_key": "property/6767906449167606/01a0102f-f655-70ed-82a0-f5dccdba75ee.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and shaded seating areas. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Pool_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_43d9e755571a02d8c4c07057",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-f861-739a-a2c5-246c80bdd825.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "01a0102f-f861-739a-a2c5-246c80bdd825",
        "storage_key": "property/6767906449167606/01a0102f-f861-739a-a2c5-246c80bdd825.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush greenery.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Pool_Angle-4_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_585aea0c75e4aa2ca53b95a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-fb0d-74b9-adf6-c593e0f0d5bb.webp",
      "image_media": {
        "alt_text": "Modern living room with a white sofa, two blue accent chairs, and a coffee table.",
        "public_id": "01a0102f-fb0d-74b9-adf6-c593e0f0d5bb",
        "storage_key": "property/6767906449167606/01a0102f-fb0d-74b9-adf6-c593e0f0d5bb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room, perfect for relaxing or entertaining, featuring comfortable seating and stylish decor.",
      "link": "false",
      "alt_text": "Modern living room with a white sofa, two blue accent chairs, and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Model-Apartment_Living-Room_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_386354b0b1de77c027f53883",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-0253-76cf-9448-48e4c14769cd.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and cardio equipment.",
        "public_id": "01a01030-0253-76cf-9448-48e4c14769cd",
        "storage_key": "property/6767906449167606/01a01030-0253-76cf-9448-48e4c14769cd.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring weight machines and cardio equipment for a complete workout.",
      "link": "false",
      "alt_text": "Gym with weight machines and cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Fitness-Center_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_4f1436845d85fe75b37d0084",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a0102f-fcdf-72a9-b766-616d687710e0.webp",
      "image_media": {
        "alt_text": "Spacious living room with a white sofa, coffee table, and dining area visible in the background.",
        "public_id": "01a0102f-fcdf-72a9-b766-616d687710e0",
        "storage_key": "property/6767906449167606/01a0102f-fcdf-72a9-b766-616d687710e0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into comfort in this inviting living area, featuring a plush white sofa, a stylish coffee table, and a connected dining space perfect for meals and gatherings.",
      "link": "false",
      "alt_text": "Spacious living room with a white sofa, coffee table, and dining area visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Model-Apartment_Living-Room_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_137c2273fe0fbd57ac596f5e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-1e58-7079-89cf-a1b048bcb4b2.webp",
      "image_media": {
        "alt_text": "Balcony with table, chairs, and view of trees.",
        "public_id": "01a01030-1e58-7079-89cf-a1b048bcb4b2",
        "storage_key": "property/6767906449167606/01a01030-1e58-7079-89cf-a1b048bcb4b2.webp",
        "width": 3000,
        "height": 2001
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening wine on your private balcony, overlooking lush greenery and a peaceful neighborhood.",
      "link": "false",
      "alt_text": "Balcony with table, chairs, and view of trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Patio_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_1b5f3b27e5554a51738377d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-238d-75f7-ad90-4edcddf3c055.webp",
      "image_media": {
        "alt_text": "Walk-in closet with organized clothing and shoes.",
        "public_id": "01a01030-238d-75f7-ad90-4edcddf3c055",
        "storage_key": "property/6767906449167606/01a01030-238d-75f7-ad90-4edcddf3c055.webp",
        "width": 3000,
        "height": 2001
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space, perfect for organizing your wardrobe.",
      "link": "false",
      "alt_text": "Walk-in closet with organized clothing and shoes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Walk-in-Closet-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_c54c6f39b22dd38c54bf540c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-1f4e-75d2-957c-555bf185715e.webp",
      "image_media": {
        "alt_text": "Outdoor balcony with table set for two with champagne and glasses.",
        "public_id": "01a01030-1f4e-75d2-957c-555bf185715e",
        "storage_key": "property/6767906449167606/01a01030-1f4e-75d2-957c-555bf185715e.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening wine on your private balcony, complete with a charming table set for two.",
      "link": "false",
      "alt_text": "Outdoor balcony with table set for two with champagne and glasses.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Patio_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_116e08cec800ec425ea59723",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-22c0-742f-b2cf-8a79e3bf9133.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wooden cabinets, and speckled countertops.",
        "public_id": "01a01030-22c0-742f-b2cf-8a79e3bf9133",
        "storage_key": "property/6767906449167606/01a01030-22c0-742f-b2cf-8a79e3bf9133.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Updated kitchen featuring a full suite of appliances, ample cabinet space, and a double sink, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white appliances, wooden cabinets, and speckled countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Kitchen_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_ddf72aa1b5996613196e79b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-2ee1-72bf-b69c-6495401066ff.webp",
      "image_media": {
        "alt_text": "Exterior patio with a small table and two chairs, leading to an apartment entrance.",
        "public_id": "01a01030-2ee1-72bf-b69c-6495401066ff",
        "storage_key": "property/6767906449167606/01a01030-2ee1-72bf-b69c-6495401066ff.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private patio. This charming outdoor space features a bistro set, perfect for intimate gatherings or peaceful moments.",
      "link": "false",
      "alt_text": "Exterior patio with a small table and two chairs, leading to an apartment entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Model-Apartment_Patio_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_2055a5d1057c4283b5f6cba0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-526c-776d-81e6-fb8f8489c43d.webp",
      "image_media": {
        "alt_text": "Patio area with two chairs and a table, adjacent to a building entrance and window.",
        "public_id": "01a01030-526c-776d-81e6-fb8f8489c43d",
        "storage_key": "property/6767906449167606/01a01030-526c-776d-81e6-fb8f8489c43d.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private patio, complete with seating and a small table. A perfect extension of your living space.",
      "link": "false",
      "alt_text": "Patio area with two chairs and a table, adjacent to a building entrance and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Model-Apartment_Patio_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_f1c3e22bff8b564fea82376b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-4dc4-778d-b2c7-a5213ce87fae.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white countertop, stainless steel sink, dishwasher, and refrigerator.",
        "public_id": "01a01030-4dc4-778d-b2c7-a5213ce87fae",
        "storage_key": "property/6767906449167606/01a01030-4dc4-778d-b2c7-a5213ce87fae.webp",
        "width": 3000,
        "height": 1999
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample wooden cabinetry, a double basin stainless steel sink, a dishwasher, and a refrigerator. Perfect for home cooking.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, white countertop, stainless steel sink, dishwasher, and refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Kitchen_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_8b21fb1e9575c767f4628ffe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-501d-7181-83cd-d222cd0de6d3.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a double sink, white stove, and round dining table with green chairs.",
        "public_id": "01a01030-501d-7181-83cd-d222cd0de6d3",
        "storage_key": "property/6767906449167606/01a01030-501d-7181-83cd-d222cd0de6d3.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "View of the kitchen and dining area, featuring a double sink, white stove, ample cabinet space, and a round dining table with four green chairs.",
      "link": "false",
      "alt_text": "Kitchen and dining area with a double sink, white stove, and round dining table with green chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Kitchen_Angle-3_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_c9ab429fc445b47167ce7800",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-540d-7323-a4c6-7fe49ee96378.webp",
      "image_media": {
        "alt_text": "Dining area with a marble-top table and green chairs, opening to a kitchen and living room.",
        "public_id": "01a01030-540d-7323-a4c6-7fe49ee96378",
        "storage_key": "property/6767906449167606/01a01030-540d-7323-a4c6-7fe49ee96378.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy meals in the dining area or relax in the spacious living room, adjacent to a well-equipped kitchen.",
      "link": "false",
      "alt_text": "Dining area with a marble-top table and green chairs, opening to a kitchen and living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Dining-Room_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_365ab260cd42d7eb44500473",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-57fb-728e-bdf2-239f9a996fd9.webp",
      "image_media": {
        "alt_text": "Walk-in closet with organized clothing and shoes on shelves.",
        "public_id": "01a01030-57fb-728e-bdf2-239f9a996fd9",
        "storage_key": "property/6767906449167606/01a01030-57fb-728e-bdf2-239f9a996fd9.webp",
        "width": 3000,
        "height": 1999
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and hanging space for all your wardrobe needs.",
      "link": "false",
      "alt_text": "Walk-in closet with organized clothing and shoes on shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Walk-in-Closet-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_48d6b8f8f97cdbafa7c118fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-79f1-72eb-b1e9-bd97948d1c3a.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, closet, and view into the bathroom.",
        "public_id": "01a01030-79f1-72eb-b1e9-bd97948d1c3a",
        "storage_key": "property/6767906449167606/01a01030-79f1-72eb-b1e9-bd97948d1c3a.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, ample closet space, and a convenient en-suite bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a bed, dresser, closet, and view into the bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Bedroom-1_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_c84965bffbdc64f26d9e69ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-7998-7589-ab2a-840d017863ef.webp",
      "image_media": {
        "alt_text": "Spacious living room with fireplace, mounted TV, and large window.",
        "public_id": "01a01030-7998-7589-ab2a-840d017863ef",
        "storage_key": "property/6767906449167606/01a01030-7998-7589-ab2a-840d017863ef.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring a cozy fireplace and ample natural light.",
      "link": "false",
      "alt_text": "Spacious living room with fireplace, mounted TV, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Living-Room_Angle-3_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_0008c9430fce249ee735f594",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-79fe-709c-a86a-33e92de0e2ef.webp",
      "image_media": {
        "alt_text": "Clean bathroom with a white bathtub, toilet, and vanity.",
        "public_id": "01a01030-79fe-709c-a86a-33e92de0e2ef",
        "storage_key": "property/6767906449167606/01a01030-79fe-709c-a86a-33e92de0e2ef.webp",
        "width": 3000,
        "height": 1999
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a white bathtub with shower, a toilet, and a spacious vanity with a speckled countertop.",
      "link": "false",
      "alt_text": "Clean bathroom with a white bathtub, toilet, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Bathroom_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_4d75cea4a1bd824ada9ed126",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-859e-73d1-b623-6e509d1f849a.webp",
      "image_media": {
        "alt_text": "A dining area with a round marble table and four green velvet chairs.",
        "public_id": "01a01030-859e-73d1-b623-6e509d1f849a",
        "storage_key": "property/6767906449167606/01a01030-859e-73d1-b623-6e509d1f849a.webp",
        "width": 3000,
        "height": 2001
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round marble-topped table with four plush green velvet chairs, perfect for intimate meals.",
      "link": "false",
      "alt_text": "A dining area with a round marble table and four green velvet chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Dining-Room_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_1e2b0a3b75f862633d6e8285",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-89ed-76de-ae44-93252fe05192.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and lush greenery.",
        "public_id": "01a01030-89ed-76de-ae44-93252fe05192",
        "storage_key": "property/6767906449167606/01a01030-89ed-76de-ae44-93252fe05192.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and surrounded by beautiful landscaping. Perfect for a sunny afternoon.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and lush greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Pool_Angle-3_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_6bdeb4ffabc7ee6cc59d1e7d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-a9e6-7252-ae4d-9bcb68598d31.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and a clubhouse.",
        "public_id": "01a01030-a9e6-7252-ae4d-9bcb68598d31",
        "storage_key": "property/6767906449167606/01a01030-a9e6-7252-ae4d-9bcb68598d31.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and soaking up the sun. Comfortable lounge chairs are available for your convenience.",
      "link": "false",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and a clubhouse.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Pool_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_abbb482ac18cb975a03599ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-ac25-74fb-b8c2-f3bdd3f5b370.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and sidewalks.",
        "public_id": "01a01030-ac25-74fb-b8c2-f3bdd3f5b370",
        "storage_key": "property/6767906449167606/01a01030-ac25-74fb-b8c2-f3bdd3f5b370.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings with lush green lawns and paved walkways, offering a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and sidewalks.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Residential-Buildings_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_8e82a89a813c5cc082d823b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-ad56-7484-ab8a-7a436b93e91b.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and mirror, toilet, and bathtub.",
        "public_id": "01a01030-ad56-7484-ab8a-7a436b93e91b",
        "storage_key": "property/6767906449167606/01a01030-ad56-7484-ab8a-7a436b93e91b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a vanity with a sink and ample counter space, a toilet, and a bathtub with a shower curtain.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink and mirror, toilet, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Model-Apartment_Bathroom_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_63ace14762bbd8fbe833068d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-af7e-7498-bb10-da578c067fa6.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machine in fitness center with view of pool.",
        "public_id": "01a01030-af7e-7498-bb10-da578c067fa6",
        "storage_key": "property/6767906449167606/01a01030-af7e-7498-bb10-da578c067fa6.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, an elliptical, and a view of the sparkling outdoor pool.",
      "link": "false",
      "alt_text": "Treadmills and elliptical machine in fitness center with view of pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Fitness-Center_Angle-4_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_b2594dc5773de3d1aa1d30b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-b1f1-709f-a66b-d82189f13adb.webp",
      "image_media": {
        "alt_text": "Gym with weight rack, exercise bike, and weight bench with a pool visible through the window.",
        "public_id": "01a01030-b1f1-709f-a66b-d82189f13adb",
        "storage_key": "property/6767906449167606/01a01030-b1f1-709f-a66b-d82189f13adb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our on-site fitness center, equipped with free weights, cardio machines, and a weight bench. Step outside to relax by the sparkling swimming pool.",
      "link": "false",
      "alt_text": "Gym with weight rack, exercise bike, and weight bench with a pool visible through the window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Fitness-Center_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_b1e58e11edec740fd1a471e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-d264-7037-b6ce-0d4cc6063e92.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a breakfast bar and dark wood dining set.",
        "public_id": "01a01030-d264-7037-b6ce-0d4cc6063e92",
        "storage_key": "property/6767906449167606/01a01030-d264-7037-b6ce-0d4cc6063e92.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy convenient and stylish living in this apartment's open-concept kitchen and dining area, featuring a breakfast bar and a spacious dining room.",
      "link": "false",
      "alt_text": "Kitchen and dining area with a breakfast bar and dark wood dining set.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Model-Apartment_Dining-Room_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_80965f3273d080f127d4e8e0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-d368-70fd-9eba-08cad1026116.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, king-sized bed, and access to a bathroom.",
        "public_id": "01a01030-d368-70fd-9eba-08cad1026116",
        "storage_key": "property/6767906449167606/01a01030-d368-70fd-9eba-08cad1026116.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-sized bed, a decorative dresser, and a ceiling fan. The room offers convenient access to the adjoining bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a dresser, king-sized bed, and access to a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Bedroom-2_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_6a360452c54c6d7f98340c94",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-cf0e-71e7-b8bf-24a0a931e512.webp",
      "image_media": {
        "alt_text": "A bedroom with a bed, two nightstands, a ceiling fan, and artwork on the wall.",
        "public_id": "01a01030-cf0e-71e7-b8bf-24a0a931e512",
        "storage_key": "property/6767906449167606/01a01030-cf0e-71e7-b8bf-24a0a931e512.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, elegant nightstands, and decorative artwork, creating a serene retreat.",
      "link": "false",
      "alt_text": "A bedroom with a bed, two nightstands, a ceiling fan, and artwork on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Bedroom-2_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_0cb91e7fc1012f1a57258202",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-d79e-7658-86fa-3fcf60ed2e54.webp",
      "image_media": {
        "alt_text": "Spacious living room with a green sofa, armchair, coffee table, and fireplace.",
        "public_id": "01a01030-d79e-7658-86fa-3fcf60ed2e54",
        "storage_key": "property/6767906449167606/01a01030-d79e-7658-86fa-3fcf60ed2e54.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Enjoy the modern and spacious living area, perfect for relaxation and entertaining, featuring a comfortable sofa, elegant armchair, and a cozy fireplace.",
      "link": "false",
      "alt_text": "Spacious living room with a green sofa, armchair, coffee table, and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Living-Room_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_96f5dd024945058146047647",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-d8ca-7038-86a0-8f4183588cef.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer in a closet next to a refrigerator and espresso machine.",
        "public_id": "01a01030-d8ca-7038-86a0-8f4183588cef",
        "storage_key": "property/6767906449167606/01a01030-d8ca-7038-86a0-8f4183588cef.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry with stacked washer and dryer, adjacent to a full-sized refrigerator and a sleek espresso machine, perfect for a modern kitchen.",
      "link": "false",
      "alt_text": "Stacked washer and dryer in a closet next to a refrigerator and espresso machine.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Laundry-Closet_Washer-and-Dryer_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_e2b128536cfc74a983f1de5c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-ebf9-742a-bede-0b5eb38a907c.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and window.",
        "public_id": "01a01030-ebf9-742a-bede-0b5eb38a907c",
        "storage_key": "property/6767906449167606/01a01030-ebf9-742a-bede-0b5eb38a907c.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a stylish dresser, and a large window with blinds. The room is well-lit and includes modern decor.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, dresser, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Bedroom-1_Angle-1_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_bb7cb3b67fc715eed382c578",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01030-fc1c-740b-9aca-332ac714ac73.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "01a01030-fc1c-740b-9aca-332ac714ac73",
        "storage_key": "property/6767906449167606/01a01030-fc1c-740b-9aca-332ac714ac73.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a single vanity with a speckled countertop, a toilet, and a bathtub/shower combination with a decorative curtain.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Staged-Interior_Bathroom_Angle-2_2026-06-11_Original-Size.jpg"
    },
    {
      "id": "ec_f82106dfc569b4fc38611d4e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01031-16a5-73a5-a855-07616592cedb.webp",
      "image_media": {
        "alt_text": "Brick building with a welcoming pathway and lush landscaping.",
        "public_id": "01a01031-16a5-73a5-a855-07616592cedb",
        "storage_key": "property/6767906449167606/01a01031-16a5-73a5-a855-07616592cedb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming brick building entrance with a paved walkway through vibrant gardens and mature trees, offering a glimpse of the property's inviting atmosphere.",
      "link": "false",
      "alt_text": "Brick building with a welcoming pathway and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Leasing-Office-Clubhouse-Exterior_2026-06-11_Original-Size(1).jpg"
    },
    {
      "id": "ec_e97f76df4d1bd2f208df9922",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01031-15c9-7368-8978-4688bfbbf674.webp",
      "image_media": {
        "alt_text": "Outdoor picnic area with tables and grill in front of apartment buildings.",
        "public_id": "01a01031-15c9-7368-8978-4688bfbbf674",
        "storage_key": "property/6767906449167606/01a01031-15c9-7368-8978-4688bfbbf674.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at the picnic area, complete with grills and seating, set against the backdrop of the community's charming architecture.",
      "link": "false",
      "alt_text": "Outdoor picnic area with tables and grill in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Pebblebrook-024_Photo_Residential-Buildings_Picnic-Table-and-BBQ-Grill_2026-06-11_Original-Size(1).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c15412b3-afa3-4166-9fa7-702a9a0d9f77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Sickies Garage Burgers & Brews",
      "poi_type": "Restaurants",
      "poi_address": "7111 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Casual spot with a car-garage vibe serving burgers (inc. unusual varieties), wings, nachos, fried pickles, onion rings, fries, chicken tenders, mozzarella sticks, macaroni and cheese, tater tots, deviled eggs and shakes, alongside beer and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-5fae-76fa-86e6-52e4d5504b8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-5fae-76fa-86e6-52e4d5504b8d",
        "storage_key": "property/6767906449167606/019ff6b2-5fae-76fa-86e6-52e4d5504b8d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://sickiesburgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7873372324216743774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sickies-garage-burgers--brews",
      "poi_latitude": "38.9562268",
      "poi_longitude": "-94.6692154",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-491-4724",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx8Z1mUTrwIcRXqdU-WnWQ20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_c8d72039-c8be-4e97-84c4-2449fc88d01c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Jack Stack Barbecue - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "9520 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_long_description": "Bustling local chain known for its vast barbecue menu encompassing steak & seafood.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-5a8b-77fb-8c5f-181e345718d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-5a8b-77fb-8c5f-181e345718d1",
        "storage_key": "property/6767906449167606/019ff6b2-5a8b-77fb-8c5f-181e345718d1.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=11966261220374441358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-stack-barbecue---overland-park",
      "poi_latitude": "38.9558013",
      "poi_longitude": "-94.6684419",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-385-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTZe4NL7rwIcRjm3zES6zEKY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_4aedf9e9-159e-4b4a-af43-7537989bdc6b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Conroy's Public House",
      "poi_type": "Restaurants",
      "poi_address": "5285 W 95th St, Overland Park, KS 66207, USA",
      "poi_short_description": "Colorful Irish pub offering diverse comfort food & breakfast, plus a patio & TV sports.",
      "poi_long_description": "Colorful Irish pub offering diverse comfort food & breakfast, plus a patio & TV sports.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-eab4-73c8-b69c-bda0c8f29608.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-eab4-73c8-b69c-bda0c8f29608",
        "storage_key": "property/6767906449167606/01a01014-eab4-73c8-b69c-bda0c8f29608.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.conroyspublichouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11049973062812423052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conroys-public-house",
      "poi_latitude": "38.9563632",
      "poi_longitude": "-94.6463955",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-648-2244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-458c-744d-8b68-9342af3f04a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-458c-744d-8b68-9342af3f04a6",
        "storage_key": "property/6767906449167606/019fc983-458c-744d-8b68-9342af3f04a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWqfwN_rwIcRjNORkvRjWZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_1eb21345-dae0-4128-8e35-0c44ed7c0292",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Houlihan's",
      "poi_type": "Restaurants",
      "poi_address": "11851 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Casual chain restaurant offering comfort food, wine, and cocktails, plus happy-hour specials.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-ec8e-7059-865e-59b1d15eb528.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-ec8e-7059-865e-59b1d15eb528",
        "storage_key": "property/6767906449167606/01a01014-ec8e-7059-865e-59b1d15eb528.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.houlihans.com/location/overland-park-houlihans/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13367718091016146027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houlihans",
      "poi_latitude": "38.9562084",
      "poi_longitude": "-94.718101",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-492-3926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJty1AEkjrwIcRa4yUUMesg7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_f1d8a110-f2d9-4cd9-8f33-8aa89de9c32b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "BIBIBOP Asian Grill",
      "poi_type": "Restaurants",
      "poi_address": "11875 W 95th St #22, Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-9ea7-717d-bce8-aebcbb997072.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-9ea7-717d-bce8-aebcbb997072",
        "storage_key": "property/6767906449167606/019fc982-9ea7-717d-bce8-aebcbb997072.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://order.bibibop.com/menu/oak-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9554475213884126309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bibibop-asian-grill",
      "poi_latitude": "38.9562384",
      "poi_longitude": "-94.7225344",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-286-0295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkVOd_wzrwIcRZXTW0pVQmIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_98cfa9ac-f95a-43d7-8ec1-5de598cf4334",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Outback Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "9501 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_long_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-e709-759d-ab00-1c4ab24e1e95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-e709-759d-ab00-1c4ab24e1e95",
        "storage_key": "property/6767906449167606/01a01014-e709-759d-ab00-1c4ab24e1e95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.outback.com/kansas/overland-park/9501-quivira-drive?utm_source=gmb&utm_medium=local_search&utm_campaign=website_cta&y_source=1_MTU1MDIxNjctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13942497219588287689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outback-steakhouse",
      "poi_latitude": "38.9552365",
      "poi_longitude": "-94.7229534",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-894-5115",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4A_PErrwIcRyWxux1mzfcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_2fb52f89-1559-4ce1-8bfa-04f95a0e162c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "9691 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-e731-75b3-b998-368d7986afde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-e731-75b3-b998-368d7986afde",
        "storage_key": "property/6767906449167606/01a01014-e731-75b3-b998-368d7986afde.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ks/overland-park/9691-metcalf-ave?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202407&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=10448183744538735952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "38.953303",
      "poi_longitude": "-94.667006",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-427-5720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-4595-71ad-ade9-d4bdd64b28bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-4595-71ad-ade9-d4bdd64b28bc",
        "storage_key": "property/6767906449167606/019fc983-4595-71ad-ade9-d4bdd64b28bc.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ0xPCWQDrwIcRUPU9QcJn_5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_8d1572c1-6333-40a0-b3ce-ab6eff778b93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Café Vie",
      "poi_type": "Restaurants",
      "poi_address": "10330 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Modern, mellow Vietnamese coffee house & patio offering casual eats, bubble teas & smoothies.",
      "poi_long_description": "Modern, mellow Vietnamese coffee house & patio offering casual eats, bubble teas & smoothies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-e9e4-739b-9f22-dfe4efa67042.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-e9e4-739b-9f22-dfe4efa67042",
        "storage_key": "property/6767906449167606/01a01014-e9e4-739b-9f22-dfe4efa67042.webp",
        "width": 1280,
        "height": 661
      },
      "poi_business_url": "https://www.cafevie-ks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6216038284479222590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-vie",
      "poi_latitude": "38.9401344",
      "poi_longitude": "-94.6704082",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-901-0565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu82Kd7brwIcRPtOcwOLNQ1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_fusion_restaurant"
    },
    {
      "id": "custom_9663fcb7-8e46-49fc-8a89-8e2a5bbaf63e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Taco Via",
      "poi_type": "Restaurants",
      "poi_address": "8896 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Mexican fast food and taco joint with laid-back seating and house pizza and nachos, plus arcade games.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-9810-7718-ba89-ed6f4eb55907.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-9810-7718-ba89-ed6f4eb55907",
        "storage_key": "property/6767906449167606/019fc982-9810-7718-ba89-ed6f4eb55907.webp",
        "width": 1280,
        "height": 629
      },
      "poi_business_url": "https://tacovia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3266268812162883899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taco-via",
      "poi_latitude": "38.9572417",
      "poi_longitude": "-94.6886523",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-649-3885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNysr-Z_rwIcRO-Hn4S0eVC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_825cf844-5308-4532-9b21-6feb059c4c08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Sushi UNI",
      "poi_type": "Restaurants",
      "poi_address": "12841 W 87th St Pkwy, Lenexa, KS 66215, USA",
      "poi_short_description": "Compact, busy strip-mall venue for traditional Japanese sushi, sashimi, salads & hot entrees.",
      "poi_long_description": "Compact, busy strip-mall venue for traditional Japanese sushi, sashimi, salads & hot entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-e6c4-701d-b078-02721d733911.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-e6c4-701d-b078-02721d733911",
        "storage_key": "property/6767906449167606/01a01014-e6c4-701d-b078-02721d733911.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ordersushiuni.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2788749059343652231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-uni",
      "poi_latitude": "38.9703578",
      "poi_longitude": "-94.7351629",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-322-8667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWQVgBqmUwIcRhxXieX6gsyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_1bafc0ae-5579-452b-8c47-7771db85204e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "The Other Place Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "7324 W 80th St, Overland Park, KS 66204, USA",
      "poi_short_description": "Sports-themed pizzeria chain with TVs, plus a menu of pies, wings, beer & more.",
      "poi_long_description": "Sports-themed pizzeria chain with TVs, plus a menu of pies, wings, beer & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-eb05-747d-83de-69f58daca069.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-eb05-747d-83de-69f58daca069",
        "storage_key": "property/6767906449167606/01a01014-eb05-747d-83de-69f58daca069.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://theotherplace.com/location/overland-park-kansas",
      "poi_directions_map_url": "https://maps.google.com/?cid=5504879631191954700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-other-place-overland-park",
      "poi_latitude": "38.9841287",
      "poi_longitude": "-94.6710351",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-652-9494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe37VXnHswIcRDNV6xNtCZUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_742b7e5d-86ae-4fcf-b34e-abc60d120a41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "11865 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_long_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-e720-7029-ba3f-3788bddd8558.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-e720-7029-ba3f-3788bddd8558",
        "storage_key": "property/6767906449167606/01a01014-e720-7029-ba3f-3788bddd8558.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cheddars.com/locations/ks/overland-park/overland-park/2094?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:overland-park-ks-2094_pl:locurl_rd:1080",
      "poi_directions_map_url": "https://maps.google.com/?cid=15551104286300398531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "38.95623",
      "poi_longitude": "-94.72209",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-599-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLeUb7EnrwIcRw2P9gfSe0Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_0c25aa94-f8ae-4fa9-9c27-1f75880a79ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Fuzzy's Taco Shop",
      "poi_type": "Restaurants",
      "poi_address": "8909 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Modern counter-service chain serving Baja-style tacos & other Mexican eats, plus beer & margaritas.",
      "poi_long_description": "Modern counter-service chain serving Baja-style tacos & other Mexican eats, plus beer & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-94e8-7009-9c5f-43ac47ea07cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-94e8-7009-9c5f-43ac47ea07cc",
        "storage_key": "property/6767906449167606/019fc982-94e8-7009-9c5f-43ac47ea07cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fuzzystacoshop.com/locations/kansas/overland-park/?utm_campaign=google_maps&utm_medium=organic&utm_source=google&utm_content=website&utm_keyword=57605",
      "poi_directions_map_url": "https://maps.google.com/?cid=8051978854763819456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fuzzys-taco-shop",
      "poi_latitude": "38.956215",
      "poi_longitude": "-94.6893645",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-291-2056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxz2n1HTrwIcRwHEncRtgvm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_71a5ccb2-d485-481e-8a91-e738f74ed173",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Bloom Baking Company Lighton Plaza",
      "poi_type": "Restaurants",
      "poi_address": "7500 College Blvd Ste 135, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-f851-771c-92a2-70a809ca3422.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f851-771c-92a2-70a809ca3422",
        "storage_key": "property/6767906449167606/01a01014-f851-771c-92a2-70a809ca3422.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://bloombakingco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6253548869841585291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bloom-baking-company-lighton-plaza",
      "poi_latitude": "38.9291313",
      "poi_longitude": "-94.6731725",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-283-8437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7UhsimLrwIcRiwR0fJARyVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0ead3385-cb6a-4c5c-85f5-aa658f3fa149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "9761 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-f4db-75cb-b4d9-402a5a5db92d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f4db-75cb-b4d9-402a5a5db92d",
        "storage_key": "property/6767906449167606/01a01014-f4db-75cb-b4d9-402a5a5db92d.webp",
        "width": 630,
        "height": 355
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/overland-park?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=6707564701520554815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "38.951986",
      "poi_longitude": "-94.6670524",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-342-8290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWUxkso3rwIcRP-sUzo4OFl0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_3e7e4ef2-f330-4e29-9eba-ac91c2e534a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Hy-Vee Grocery Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "8501 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Supermarket with fresh and organic produce as well as a bakery.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-b62d-743e-9b43-6d7a9a585528.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-b62d-743e-9b43-6d7a9a585528",
        "storage_key": "property/6767906449167606/019fc982-b62d-743e-9b43-6d7a9a585528.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hy-vee.com/stores/detail.aspx?s=128&utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11669836886695708453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-grocery-store",
      "poi_latitude": "38.955555",
      "poi_longitude": "-94.683945",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-894-1983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea03-747d-881e-9bb498988c82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea03-747d-881e-9bb498988c82",
        "storage_key": "property/6767906449167606/019fc980-ea03-747d-881e-9bb498988c82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7xEOmOzrwIcRJYc_qtGW86E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_151d5443-413f-40d0-836a-1e04569d13a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "8333 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-b381-77b8-b7d0-cd8d7195b229.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-b381-77b8-b7d0-cd8d7195b229",
        "storage_key": "property/6767906449167606/019fc982-b381-77b8-b7d0-cd8d7195b229.webp",
        "width": 1280,
        "height": 586
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ks/overland-park/8333-w-95th/f319",
      "poi_directions_map_url": "https://maps.google.com/?cid=8904277205991232046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.956629",
      "poi_longitude": "-94.682176",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea03-747d-881e-9bb498988c82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea03-747d-881e-9bb498988c82",
        "storage_key": "property/6767906449167606/019fc980-ea03-747d-881e-9bb498988c82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1c74KHrwIcRLhK3JPFYkns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_f620bfd5-0824-45d6-95bd-3235561b1d75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Walmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "7701 Frontage Rd, Overland Park, KS 66204, USA",
      "poi_short_description": "Grocery and household goods are sold at this store, which also provides pharmacy services and optometric care.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-2a83-75aa-b493-1334ac71f18e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-2a83-75aa-b493-1334ac71f18e",
        "storage_key": "property/6767906449167606/019fc983-2a83-75aa-b493-1334ac71f18e.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1691-overland-park-ks?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16580119918847404756&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart",
      "poi_latitude": "38.9896418",
      "poi_longitude": "-94.6988084",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-648-5885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea02-74cf-9141-adb261ee48e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea02-74cf-9141-adb261ee48e3",
        "storage_key": "property/6767906449167606/019fc980-ea02-74cf-9141-adb261ee48e3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7Vm5UZDswIcR1CpHkDhrGOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_905c09b0-06d6-4dbf-a63d-877a805831c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8800 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-5ef3-70e2-8ed1-f0747ad1ef8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-5ef3-70e2-8ed1-f0747ad1ef8c",
        "storage_key": "property/6767906449167606/019ff6b2-5ef3-70e2-8ed1-f0747ad1ef8c.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/8800-w-95th-street-overland-park-ks-66212/storeid=8582?WT.mc_id=LS_GOOGLE_RX_8582",
      "poi_directions_map_url": "https://maps.google.com/?cid=12371330973486656191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.95741659999999",
      "poi_longitude": "-94.6872668",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-381-8184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-45e7-740a-bf18-fe25147b3abd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-45e7-740a-bf18-fe25147b3abd",
        "storage_key": "property/6767906449167606/019fc983-45e7-740a-bf18-fe25147b3abd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5WqwQ3XrwIcRv6p1afnLr6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_213f6165-7ccb-403f-99e9-8c05513d0efc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Cosentino's Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "3700 W 95th St, Leawood, KS 66206, USA",
      "poi_short_description": "Clean supermarket featuring organic options and a deli, plus friendly service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-f782-701e-85ee-28bfdc04c52a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-f782-701e-85ee-28bfdc04c52a",
        "storage_key": "property/6767906449167606/01a01014-f782-701e-85ee-28bfdc04c52a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=81",
      "poi_directions_map_url": "https://maps.google.com/?cid=13400331916150255809&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-price-chopper",
      "poi_latitude": "38.9577569",
      "poi_longitude": "-94.6284193",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-648-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea03-747d-881e-9bb498988c82.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea03-747d-881e-9bb498988c82",
        "storage_key": "property/6767906449167606/019fc980-ea03-747d-881e-9bb498988c82.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGfymG2rpwIcRwTB3NuGK97k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f8718358-ce05-4250-81e8-a853a632a0e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Oak Park Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "11149 W 95th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_long_description": "Busy, long-standing indoor shopping destination with 2 levels of popular brands & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6af-4b17-75a5-9a66-3d6fd021a8f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6af-4b17-75a5-9a66-3d6fd021a8f6",
        "storage_key": "property/6767906449167606/019ff6af-4b17-75a5-9a66-3d6fd021a8f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shopoakparkmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751688215534709327&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall",
      "poi_latitude": "38.9530939",
      "poi_longitude": "-94.7196254",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-888-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea02-74cf-9141-adb261ee48e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea02-74cf-9141-adb261ee48e3",
        "storage_key": "property/6767906449167606/019fc980-ea02-74cf-9141-adb261ee48e3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzVbG9zXrwIcRTyr3Ao6sEDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4e903159-6fc5-4a80-9bca-83a4e054fc71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "11501 W 97th St, Overland Park, KS 66214, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-64b1-734f-80d9-54cd665982e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-64b1-734f-80d9-54cd665982e3",
        "storage_key": "property/6767906449167606/019ff6b2-64b1-734f-80d9-54cd665982e3.webp",
        "width": 1280,
        "height": 699
      },
      "poi_business_url": "https://www.target.com/sl/overland-park-west/2043",
      "poi_directions_map_url": "https://maps.google.com/?cid=11588226477518387963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.95072090000001",
      "poi_longitude": "-94.7195414",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-905-0285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea02-74cf-9141-adb261ee48e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea02-74cf-9141-adb261ee48e3",
        "storage_key": "property/6767906449167606/019fc980-ea02-74cf-9141-adb261ee48e3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_Vxe5zbrwIcR-3pCkZWm0aA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9705490c-1121-43e3-911a-1e357920d108",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "8700 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-c3db-755a-aeed-855404a39786.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-c3db-755a-aeed-855404a39786",
        "storage_key": "property/6767906449167606/019fc982-c3db-755a-aeed-855404a39786.webp",
        "width": 1280,
        "height": 735
      },
      "poi_business_url": "https://www.7-eleven.com/locations/ks/overland-park/8700-west-95th-st-25726?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10559320872189285783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "38.9571333",
      "poi_longitude": "-94.6867216",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-648-5036",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-4591-72fc-99b7-85dbdd807d96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-4591-72fc-99b7-85dbdd807d96",
        "storage_key": "property/6767906449167606/019fc983-4591-72fc-99b7-85dbdd807d96.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJGw9NV3XrwIcRl9U1OGM-ipI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_aa71471f-4bc0-441f-8e3c-46fb6610cf04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "7701 Metcalf Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-612d-7055-ba55-b6b5571e6b8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-612d-7055-ba55-b6b5571e6b8e",
        "storage_key": "property/6767906449167606/019ff6b2-612d-7055-ba55-b6b5571e6b8e.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ks/overland-park/7701-metcalf-ave?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQyNTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5002497577183671330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "38.9890096",
      "poi_longitude": "-94.6669524",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-381-0342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-e8f8-769b-9a97-68a68e1170ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b2-e8f8-769b-9a97-68a68e1170ea",
        "storage_key": "property/6767906449167606/019ff6b2-e8f8-769b-9a97-68a68e1170ea.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1DcZ23swIcRIvTIxQpxbEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_76d17a68-1ede-40a5-8815-5c50a766d2c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Trailwood Elementary School",
      "poi_type": "Education",
      "poi_address": "5101 W 95th St, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-e889-747b-a7a3-a5fdb798b339.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-e889-747b-a7a3-a5fdb798b339",
        "storage_key": "property/6767906449167606/019fc982-e889-747b-a7a3-a5fdb798b339.webp",
        "width": 1280,
        "height": 829
      },
      "poi_business_url": "http://trailwood.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14075930468404917939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trailwood-elementary-school",
      "poi_latitude": "38.9564776",
      "poi_longitude": "-94.6443974",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-993-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh1NASmDpwIcRs3Zf_C7AV8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_eef92e32-e409-4ba4-8cbc-2ad38196d28f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Brookridge Elementary",
      "poi_type": "Education",
      "poi_address": "9920 Lowell Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-d9b3-767e-bb92-2c88330db715.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-d9b3-767e-bb92-2c88330db715",
        "storage_key": "property/6767906449167606/019fc982-d9b3-767e-bb92-2c88330db715.webp",
        "width": 1280,
        "height": 828
      },
      "poi_business_url": "http://brookridge.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9476763802550548934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookridge-elementary",
      "poi_latitude": "38.9487623",
      "poi_longitude": "-94.6779126",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-993-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1S6G23nswIcRxjlO53c6hIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2e478052-f0a6-41c0-88d8-75273c9100fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "John Diemer Elementary School",
      "poi_type": "Education",
      "poi_address": "9600 Lamar Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-6926-727f-b890-3acf5a977eb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-6926-727f-b890-3acf5a977eb1",
        "storage_key": "property/6767906449167606/019ff6b2-6926-727f-b890-3acf5a977eb1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://diemer.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9840290553439266317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-diemer-elementary-school",
      "poi_latitude": "38.9543216",
      "poi_longitude": "-94.659156",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-993-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJadfApcPrwIcRDSZhTB-8j4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f6bf3742-cd50-4adc-bbaa-bbeb38f70351",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Indian Woods Middle School",
      "poi_type": "Education",
      "poi_address": "9700 Woodson Dr, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-6e1a-736b-88e0-102016cf0f26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-6e1a-736b-88e0-102016cf0f26",
        "storage_key": "property/6767906449167606/019ff6b2-6e1a-736b-88e0-102016cf0f26.webp",
        "width": 1280,
        "height": 782
      },
      "poi_business_url": "https://indianwoods.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11708930099391460908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "indian-woods-middle-school",
      "poi_latitude": "38.9522694",
      "poi_longitude": "-94.6552064",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-993-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4bUrTdvrwIcRLHYbiuN5fqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_1006dda8-b9fc-4aec-b22a-cda54d72550f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Shawnee Mission West High School",
      "poi_type": "Education",
      "poi_address": "8800 W 85th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-e25d-762d-8818-6942afed6306.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-e25d-762d-8818-6942afed6306",
        "storage_key": "property/6767906449167606/019fc982-e25d-762d-8818-6942afed6306.webp",
        "width": 1280,
        "height": 662
      },
      "poi_business_url": "http://smwest.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1174450894079124931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-west-high-school",
      "poi_latitude": "38.9764917",
      "poi_longitude": "-94.688317",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-993-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG5Gk03_rwIcRw-W5m918TBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_de13f8d4-c8a2-442b-b087-a1123dd5e6e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Shawnee Mission South High School",
      "poi_type": "Education",
      "poi_address": "5800 W 107th St, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-fe8e-7338-b6ca-c1b7504546e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-fe8e-7338-b6ca-c1b7504546e4",
        "storage_key": "property/6767906449167606/01a01014-fe8e-7338-b6ca-c1b7504546e4.webp",
        "width": 1280,
        "height": 742
      },
      "poi_business_url": "https://smsouth.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3539070587316418831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-south-high-school",
      "poi_latitude": "38.9373596",
      "poi_longitude": "-94.6535918",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-993-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpYRoydLrwIcRDzkHyPJNHTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_eccdaba9-231c-44a1-822f-6d521ec512f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Holy Cross Catholic School and Early Education",
      "poi_type": "Education",
      "poi_address": "8101 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.holycrosscatholicschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2382469803957117472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-cross-catholic-school-and-early-education",
      "poi_latitude": "38.9562788",
      "poi_longitude": "-94.6792206",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-381-7408",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ71Ae6LrwIcRIGL18Kk7ECE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_eeec07d0-7a6d-48d2-abd7-4503ecabc469",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc97f-56ce-70cf-b973-ed7cebbc6692.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97f-56ce-70cf-b973-ed7cebbc6692",
        "storage_key": "property/6767906449167606/019fc97f-56ce-70cf-b973-ed7cebbc6692.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b881fb8a-ecdf-4da9-a921-419ad21cd88a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Primrose School of Prairie Village",
      "poi_type": "Education",
      "poi_address": "5340 W 95th St, Prairie Village, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-fbe4-73d1-aa98-416242edbe4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-fbe4-73d1-aa98-416242edbe4d",
        "storage_key": "property/6767906449167606/01a01014-fbe4-73d1-aa98-416242edbe4d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.primroseschools.com/schools/prairie-village/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1713230159950269956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-prairie-village",
      "poi_latitude": "38.9574777",
      "poi_longitude": "-94.6475171",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-440-4120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0cjfIyHrwIcRBE5S3sCdxhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_bddf629f-fb7c-408d-b941-a37da7521e03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Shawnee Mission Early Childhood Education Center",
      "poi_type": "Education",
      "poi_address": "6701 W 83rd St, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://earlychildcenter.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7433875941536831061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shawnee-mission-early-childhood-education-center",
      "poi_latitude": "38.9779553",
      "poi_longitude": "-94.6639263",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-993-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYfHNg8TrwIcRVRagT8huKmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d544f47d-b322-4178-ae1c-74907a7ca4e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Johnson County Arts And Heritage Center",
      "poi_type": "Entertainment",
      "poi_address": "8788 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Cultural center featuring the Johnson County Museum, the KidScape experience, and a theater.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-decc-772c-9a35-ba69f3e7d7d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-decc-772c-9a35-ba69f3e7d7d6",
        "storage_key": "property/6767906449167606/019fc982-decc-772c-9a35-ba69f3e7d7d6.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.jcprd.com/327/Arts-Heritage-Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6564331375929992564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-arts-and-heritage-center",
      "poi_latitude": "38.9698449",
      "poi_longitude": "-94.6681692",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-826-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2a8po3rwIcRdCVCapswGVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "custom_cbe0379b-1ee6-42a7-8236-11683845b535",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc97f-8e5a-762b-b224-d1e38ae80141.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97f-8e5a-762b-b224-d1e38ae80141",
        "storage_key": "property/6767906449167606/019fc97f-8e5a-762b-b224-d1e38ae80141.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea05-73da-a604-2cea5e746eec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea05-73da-a604-2cea5e746eec",
        "storage_key": "property/6767906449167606/019fc980-ea05-73da-a604-2cea5e746eec.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_69d0f39b-5611-453e-90d1-88550dbc8a0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc97f-9872-76fd-b759-275b0e363067.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97f-9872-76fd-b759-275b0e363067",
        "storage_key": "property/6767906449167606/019fc97f-9872-76fd-b759-275b0e363067.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8d7583ac-871d-402e-ade7-f05dc70a2b0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "iFLY Indoor Skydiving - Kansas City",
      "poi_type": "Entertainment",
      "poi_address": "10975 Metcalf Ave, Overland Park, KS 66210, USA",
      "poi_short_description": "State-of-the-art wind tunnels are used for indoor skydiving at this family-friendly entertainment center.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-fce9-7464-82f3-d2a6508abc73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-fce9-7464-82f3-d2a6508abc73",
        "storage_key": "property/6767906449167606/01a01014-fce9-7464-82f3-d2a6508abc73.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.iflyworld.com/kansas-city/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2133132905847574967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---kansas-city",
      "poi_latitude": "38.93024",
      "poi_longitude": "-94.666288",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-305-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2wSq70nqwIcRt9G9dxNpmh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_fe542562-491a-4333-8d02-84440fc9535f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Andretti Indoor Karting & Games Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "11610 Nall Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01014-ffbe-7388-8884-1181de0ce381.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01014-ffbe-7388-8884-1181de0ce381",
        "storage_key": "property/6767906449167606/01a01014-ffbe-7388-8884-1181de0ce381.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://andrettikarting.com/overlandpark",
      "poi_directions_map_url": "https://maps.google.com/?cid=12146707873347930037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andretti-indoor-karting--games-overland-park",
      "poi_latitude": "38.91818490000001",
      "poi_longitude": "-94.6498735",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-937-4201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VUXQDrwIcRtQdYbXTGkag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_3168f466-c371-4aff-b68c-a4633bdfa444",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-7334-707e-b1dd-fdee47974357.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-7334-707e-b1dd-fdee47974357",
        "storage_key": "property/6767906449167606/019ff6b2-7334-707e-b1dd-fdee47974357.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-594383e2b4af",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-594383e2b4af.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7488d0ea-61de-4ab0-9b8a-82ada3a6d275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-f00a-7668-88e0-29d3c8017531.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-f00a-7668-88e0-29d3c8017531",
        "storage_key": "property/6767906449167606/019fc982-f00a-7668-88e0-29d3c8017531.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9f97bfd4-52c4-4b95-b611-93f7206d2c9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-fb3e-72c8-a65c-510b16dc44bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-fb3e-72c8-a65c-510b16dc44bd",
        "storage_key": "property/6767906449167606/019fc982-fb3e-72c8-a65c-510b16dc44bd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "12.2",
      "poi_walking_minutes": "4 hours 32 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_2a075a26-e00b-4067-936c-99c15bb530a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "AMC Town Center 20",
      "poi_type": "Entertainment",
      "poi_address": "11701 Nall Ave, Leawood, KS 66211, USA",
      "poi_short_description": "Modern cinema equipped with comfy seats, luxury recliners, and a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-02cd-75ae-807d-70f07a484a70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-02cd-75ae-807d-70f07a484a70",
        "storage_key": "property/6767906449167606/01a01015-02cd-75ae-807d-70f07a484a70.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-town-center-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804340900304979407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-town-center-20",
      "poi_latitude": "38.915838",
      "poi_longitude": "-94.648325",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-498-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-45db-76e8-98b3-8601972c1d30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-45db-76e8-98b3-8601972c1d30",
        "storage_key": "property/6767906449167606/019fc983-45db-76e8-98b3-8601972c1d30.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xgReh_qwIcRzwXH1zAF6yY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_11b591b4-144e-4bf6-a08a-17f5f351e4a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Last Call Cocktail Lounge",
      "poi_type": "Restaurants",
      "poi_address": "12687 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-072d-7796-948c-4f4ad31500cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-072d-7796-948c-4f4ad31500cd",
        "storage_key": "property/6767906449167606/01a01015-072d-7796-948c-4f4ad31500cd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lastcallspeakeasy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091038620425416437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "last-call-cocktail-lounge",
      "poi_latitude": "38.898945",
      "poi_longitude": "-94.6660459",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-232-7474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-458c-744d-8b68-9342af3f04a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-458c-744d-8b68-9342af3f04a6",
        "storage_key": "property/6767906449167606/019fc983-458c-744d-8b68-9342af3f04a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_F-gvvrwIcR9W7wtBKRL-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_24528058-e047-4b53-9197-9fcf4b81aa01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-312f-72b9-a464-59c8f815cf45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-312f-72b9-a464-59c8f815cf45",
        "storage_key": "property/6767906449167606/019fc983-312f-72b9-a464-59c8f815cf45.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea01-744a-b7ca-dc6057ae76bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea01-744a-b7ca-dc6057ae76bc",
        "storage_key": "property/6767906449167606/019fc980-ea01-744a-b7ca-dc6057ae76bc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f3f3c18d-bafa-41f1-a14e-277503adab4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Saint Luke's Convenient Care - Hy-Vee 95th & Antioch",
      "poi_type": "Health and Wellness",
      "poi_address": "8501 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-fda9-70ee-b892-495b02a8ecff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-fda9-70ee-b892-495b02a8ecff",
        "storage_key": "property/6767906449167606/019fc982-fda9-70ee-b892-495b02a8ecff.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/samedaycare?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=7005954362786686182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-convenient-care---hy-vee-95th--antioch",
      "poi_latitude": "38.9558212",
      "poi_longitude": "-94.6844396",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-323-8880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhcJNLaDrwIcR5qR_sl8mOmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_28f1226e-1a98-4670-b09a-45e790a3f301",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Overland Park North",
      "poi_type": "Health and Wellness",
      "poi_address": "9507 Antioch Rd, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-02e1-75b6-912c-b41f89cfea9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-02e1-75b6-912c-b41f89cfea9b",
        "storage_key": "property/6767906449167606/01a01015-02e1-75b6-912c-b41f89cfea9b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/overland-park-north?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17796506606246617401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---overland-park-north",
      "poi_latitude": "38.9558927",
      "poi_longitude": "-94.6859458",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-227-4631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZTQ_5_rwIcROeE47Hfk-fY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_0320a637-ab30-4e6d-9f6b-6652006fdab1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Hy-Vee Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8501 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-0240-74ee-b6ac-6007075e22bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-0240-74ee-b6ac-6007075e22bb",
        "storage_key": "property/6767906449167606/019fc983-0240-74ee-b6ac-6007075e22bb.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "https://www.hy-vee.com/my-pharmacy/pharmacy-finder/overland-park-1-8501-w-95th-st-overland-park-ks/1508?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1246817757684703566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-pharmacy",
      "poi_latitude": "38.9555875",
      "poi_longitude": "-94.6837171",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-894-2079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-45e7-740a-bf18-fe25147b3abd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-45e7-740a-bf18-fe25147b3abd",
        "storage_key": "property/6767906449167606/019fc983-45e7-740a-bf18-fe25147b3abd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx63xiJ_rwIcRTiFyCiWWTRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ffebc6dc-4938-468d-86ce-13b60d6595cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "9500 Antioch Rd, Overland Park, KS 66212, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-bdf5-70f0-8230-f1202b33f111.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-bdf5-70f0-8230-f1202b33f111",
        "storage_key": "property/6767906449167606/019fc982-bdf5-70f0-8230-f1202b33f111.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-9500+antioch+rd-overland+park-ks-66212/id=11370",
      "poi_directions_map_url": "https://maps.google.com/?cid=15822532587315318245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "38.9561947",
      "poi_longitude": "-94.6869725",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-381-0138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-45e7-740a-bf18-fe25147b3abd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-45e7-740a-bf18-fe25147b3abd",
        "storage_key": "property/6767906449167606/019fc983-45e7-740a-bf18-fe25147b3abd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD9KcrQrrwIcR5c34iY7tlNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_11895466-0888-4ba9-adc8-a13aa9318f93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8809 W 95th St, Overland Park, KS 66212, USA",
      "poi_short_description": "Chain fitness center offering 24-hour access, plus personal training and group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-7c3f-74f2-af4a-57954a838559.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-7c3f-74f2-af4a-57954a838559",
        "storage_key": "property/6767906449167606/019ff6b2-7c3f-74f2-af4a-57954a838559.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/overland-park-kansas-5338/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=255",
      "poi_directions_map_url": "https://maps.google.com/?cid=14420210980381975777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "38.9558612",
      "poi_longitude": "-94.6885189",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-871-7461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyETlL3rwIcR4eTaL3zhHsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_167838a0-b1cb-432f-a9e5-f0e57b047ce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9538 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Heart-rate training for all fitness levels in studios with heart-rate monitors, treadmills and rowing machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-0fce-775e-91a3-426799d6a249.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-0fce-775e-91a3-426799d6a249",
        "storage_key": "property/6767906449167606/01a01015-0fce-775e-91a3-426799d6a249.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/overland-park-kansas-0514?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=4615430848133583991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "38.9552057",
      "poi_longitude": "-94.6511832",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-440-0010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_ZUy93rwIcRd9RhHOdNDUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4009f85d-345e-453d-85d8-a05a212dde50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "YogaSix Overland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "6555 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "Relaxed yoga studio offering a variety of classes including hot and restorative types, plus a shop selling yoga apparel.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-06ad-7445-95ca-3a10cf5ae00c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-06ad-7445-95ca-3a10cf5ae00c",
        "storage_key": "property/6767906449167606/01a01015-06ad-7445-95ca-3a10cf5ae00c.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.yogasix.com/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4666487347789615135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix-overland-park",
      "poi_latitude": "38.9124848",
      "poi_longitude": "-94.6603913",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-660-9230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkS5c-rTrwIcRH9DayYSxwkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_9b850339-4f14-4b71-8a9c-47b4dc80570d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9331 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "Friendly chain gym offering treadmills and other equipment, plus classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc97f-a31e-727a-99db-9cf115d4fbcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97f-a31e-727a-99db-9cf115d4fbcf",
        "storage_key": "property/6767906449167606/019fc97f-a31e-727a-99db-9cf115d4fbcf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/overland-park-93rd-quivira-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9830202165263287199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.9596389",
      "poi_longitude": "-94.7231493",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-717-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3RFIs6UwIcRn0PLYsnka4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3f76d18d-5d69-4661-8d3f-fb5a300ed8d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Cherokee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8000 W 91st Terrace, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-1521-76e2-8e83-f5728ddc45a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-1521-76e2-8e83-f5728ddc45a9",
        "storage_key": "property/6767906449167606/019fc983-1521-76e2-8e83-f5728ddc45a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/park/cherokee-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6589645439464770004&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherokee-park",
      "poi_latitude": "38.96370659999999",
      "poi_longitude": "-94.6792681",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea5d-75d8-a18f-c8437d8d153e",
        "storage_key": "property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-VLBupvrwIcR1AkSH50fc1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_291d0056-37c4-4257-b8ae-b5f21d3466ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Pinehurst Mischel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9900 Hardy St, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-1614-7109-9c84-b1170d8c1029.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-1614-7109-9c84-b1170d8c1029",
        "storage_key": "property/6767906449167606/01a01015-1614-7109-9c84-b1170d8c1029.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14716339670529959443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinehurst-mischel-park",
      "poi_latitude": "38.9502484",
      "poi_longitude": "-94.6813702",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea5d-75d8-a18f-c8437d8d153e",
        "storage_key": "property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJl1eno6brwIcRE2btt_XwOsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f203f3c6-c1ac-43b6-a772-9405b88ca48c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Meadowbrook Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9101 Nall Ave, Prairie Village, KS 66207, USA",
      "poi_short_description": "Sprawling park featuring multiple playgrounds for kids of all ages, along with green space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc97f-e56e-713c-b1da-8df35e72090c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97f-e56e-713c-b1da-8df35e72090c",
        "storage_key": "property/6767906449167606/019fc97f-e56e-713c-b1da-8df35e72090c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.jcprd.com/Facilities/Facility/Details/Meadowbrook-Park-98",
      "poi_directions_map_url": "https://maps.google.com/?cid=8679418729395100578&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadowbrook-park",
      "poi_latitude": "38.9631821",
      "poi_longitude": "-94.6475643",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-826-2975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea5d-75d8-a18f-c8437d8d153e",
        "storage_key": "property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAeH28yzrwIcRopt3Tll9c3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ebf8b056-8615-4704-886c-b2d113fc6e5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Foxhill North Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10600 Indian Creek Pkwy, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-213a-756b-ae1a-5f5d788f294e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-213a-756b-ae1a-5f5d788f294e",
        "storage_key": "property/6767906449167606/019fc983-213a-756b-ae1a-5f5d788f294e.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17582387207876562711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foxhill-north-park",
      "poi_latitude": "38.9373779",
      "poi_longitude": "-94.636846",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea5d-75d8-a18f-c8437d8d153e",
        "storage_key": "property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNQtUgoLpwIcRF8_alAIwAfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6edac3a9-af48-408e-acd1-c935f18cfe74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Nall Hills Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5501 Indian Creek Dr, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-915c-718b-88a2-73a899def785.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-915c-718b-88a2-73a899def785",
        "storage_key": "property/6767906449167606/019ff6b2-915c-718b-88a2-73a899def785.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/park/nall-hills-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15640790860681485836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nall-hills-park",
      "poi_latitude": "38.938963",
      "poi_longitude": "-94.651414",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea5d-75d8-a18f-c8437d8d153e",
        "storage_key": "property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3cm1f7rwIcRDJ4YWWtAD9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fbb9da77-853d-4c72-9d86-3811977c7ddd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Nall Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Nall Hill Park, Indian Creek Bike Trail, Overland Park, KS 66207, USA",
      "poi_short_description": "Busy creek-adjacent space for soccer, picnics and birthdays, along with playground structures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-2071-7644-a03d-351980962bcc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-2071-7644-a03d-351980962bcc",
        "storage_key": "property/6767906449167606/019fc983-2071-7644-a03d-351980962bcc.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://www.opkansas.org/things-to-see-and-do/parks/list-of-city-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6609995915915217154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nall-park",
      "poi_latitude": "38.9384171",
      "poi_longitude": "-94.6475067",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea5d-75d8-a18f-c8437d8d153e",
        "storage_key": "property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGxxI5dTrwIcRAsnopkNsu1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_613bcbf3-62d5-4bcd-af31-6edf59b938ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Roe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10400 Roe Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "40-acre green space boasting a swimming pool, sports courts, a playground & hiking/biking trails.",
      "poi_long_description": "40-acre green space boasting a swimming pool, sports courts, a playground & hiking/biking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc97f-ea26-76ed-9c31-25f2bb1118a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc97f-ea26-76ed-9c31-25f2bb1118a6",
        "storage_key": "property/6767906449167606/019fc97f-ea26-76ed-9c31-25f2bb1118a6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/park/roe-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5745814544235702059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roe-park",
      "poi_latitude": "38.939606",
      "poi_longitude": "-94.6420669",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea5d-75d8-a18f-c8437d8d153e",
        "storage_key": "property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWhkHX_pwIcRKydxpuI7vU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6b573324-6ab3-4308-8c6b-ede43a95c3a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Regency Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14800 Lamar Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Playground, swings and slides at this chill park featuring a lake and walking paths.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-197b-7187-9d4e-4edd171f5d42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-197b-7187-9d4e-4edd171f5d42",
        "storage_key": "property/6767906449167606/01a01015-197b-7187-9d4e-4edd171f5d42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15463142209822193210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regency-lake-park",
      "poi_latitude": "38.8596074",
      "poi_longitude": "-94.6614219",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea5d-75d8-a18f-c8437d8d153e",
        "storage_key": "property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQkARJnBwIcROvbMn-kdmNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5a511c5b-6733-47e9-b3e3-c22040541107",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "On Metcalf at 95th St Northbound Nearside",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-2765-7392-bde7-6b742bf2fce9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-2765-7392-bde7-6b742bf2fce9",
        "storage_key": "property/6767906449167606/019fc983-2765-7392-bde7-6b742bf2fce9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9791369878109025118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-metcalf-at-95th-st-northbound-nearside",
      "poi_latitude": "38.9561384",
      "poi_longitude": "-94.6673748",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-45fc-733c-a4a8-381df7ef7726.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-45fc-733c-a4a8-381df7ef7726",
        "storage_key": "property/6767906449167606/019fc983-45fc-733c-a4a8-381df7ef7726.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJg3TIxL_rwIcRXvMl-Qbv4Yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_18d21e27-e1ca-4265-a4b6-81220c04becf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-45ee-768c-a3bd-2c7a419b0f38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-45ee-768c-a3bd-2c7a419b0f38",
        "storage_key": "property/6767906449167606/019fc983-45ee-768c-a3bd-2c7a419b0f38.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_79a537ca-ba01-4c42-a4b0-dcfb135f75fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Heartland Community Church",
      "poi_type": "Transportation & Transit",
      "poi_address": "12175 S Strang Line Rd, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-15e9-7109-87b3-d070c6bd1533.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-15e9-7109-87b3-d070c6bd1533",
        "storage_key": "property/6767906449167606/01a01015-15e9-7109-87b3-d070c6bd1533.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.heartlandchurch.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11439840584445010142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heartland-community-church",
      "poi_latitude": "38.9077079",
      "poi_longitude": "-94.7721404",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-341-5820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-e92d-740a-8d20-394279b36b69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b2-e92d-740a-8d20-394279b36b69",
        "storage_key": "property/6767906449167606/019ff6b2-e92d-740a-8d20-394279b36b69.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJtZEk2J6VwIcR3iDxkmZ6wp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_10cadbc2-20ea-4f5e-a5b3-285c42db4ebf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "119th And Quivira Office Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "119th And Quivira Office Park, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7050887734737268628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "119th-and-quivira-office-park",
      "poi_latitude": "38.9112345",
      "poi_longitude": "-94.7245193",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvfz2pbXqwIcRlG8snAnJ2WE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e065d938-2676-4b3f-a087-667cff1ab75a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Enterprise Rent-A-Car",
      "poi_type": "Transportation & Transit",
      "poi_address": "10661 Metcalf Ave, Overland Park, KS 66212, USA",
      "poi_short_description": "Chain providing a range of rental cars at an Overland Park location.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-1bd9-7475-a63e-8c62d654f80b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-1bd9-7475-a63e-8c62d654f80b",
        "storage_key": "property/6767906449167606/01a01015-1bd9-7475-a63e-8c62d654f80b.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.enterprise.com/en/car-rental-locations/us/ks/overland-park-107th-metcalf-0514.html?mcid=yext:245709",
      "poi_directions_map_url": "https://maps.google.com/?cid=9581938790718933515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enterprise-rent-a-car",
      "poi_latitude": "38.9345851",
      "poi_longitude": "-94.6666253",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-642-9669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-2b94-77fe-b9e2-a28f55771084.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a01015-2b94-77fe-b9e2-a28f55771084",
        "storage_key": "property/6767906449167606/01a01015-2b94-77fe-b9e2-a28f55771084.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8eWAkUrqwIcRC4pWGJDi-YQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "car_rental"
    },
    {
      "id": "custom_186e5f64-40d8-4632-b3ca-d55e435901fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-45ee-768c-a3bd-2c7a419b0f38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-45ee-768c-a3bd-2c7a419b0f38",
        "storage_key": "property/6767906449167606/019fc983-45ee-768c-a3bd-2c7a419b0f38.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_699cfc5a-44e0-452d-bdbf-ade407fa35be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-8fb0-737e-ba51-7bab62fa7396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6b2-8fb0-737e-ba51-7bab62fa7396",
        "storage_key": "property/6767906449167606/019ff6b2-8fb0-737e-ba51-7bab62fa7396.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "33.8",
      "poi_walking_minutes": "12 hours 36 mins",
      "poi_biking_minutes": "3 hours 42 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019ff6b2-e94b-772c-a3ca-56db45d980cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6b2-e94b-772c-a3ca-56db45d980cf",
        "storage_key": "property/6767906449167606/019ff6b2-e94b-772c-a3ca-56db45d980cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_c5b7e0ee-e8ed-426a-80b8-154e276b23b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-307a-7080-bad6-1cdb023b9918.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-307a-7080-bad6-1cdb023b9918",
        "storage_key": "property/6767906449167606/019fc983-307a-7080-bad6-1cdb023b9918.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_89127170-33c8-4c18-8e64-586eaa5a486d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc982-f8fd-717d-9a23-04fae416ea4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc982-f8fd-717d-9a23-04fae416ea4d",
        "storage_key": "property/6767906449167606/019fc982-f8fd-717d-9a23-04fae416ea4d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea01-744a-b7ca-dc6057ae76bc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea01-744a-b7ca-dc6057ae76bc",
        "storage_key": "property/6767906449167606/019fc980-ea01-744a-b7ca-dc6057ae76bc.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_ef47782d-194f-4e16-a923-aa0185874eea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Aspiria",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6140 Sprint Pkwy STE 125, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-300f-7192-a7d2-a351e6170ba5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-300f-7192-a7d2-a351e6170ba5",
        "storage_key": "property/6767906449167606/019fc983-300f-7192-a7d2-a351e6170ba5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://aspiriakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6433786320914474865&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aspiria",
      "poi_latitude": "38.9169728",
      "poi_longitude": "-94.6568885",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-285-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0ZxsczrwIcRceffOpJmSVk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9249b42a-0f4b-4df6-9916-2dbd46af914d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-3b57-753d-8087-031d2262f184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-3b57-753d-8087-031d2262f184",
        "storage_key": "property/6767906449167606/019fc983-3b57-753d-8087-031d2262f184.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea54-736a-8303-55f85bed8d69",
        "storage_key": "property/6767906449167606/019fc980-ea54-736a-8303-55f85bed8d69.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dfe12e35-9987-4ec4-ab44-df8051c156e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "OptumRx Fulfillment",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 W 115th St #600, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-1e3a-7299-8d34-7f6d5d87d5e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-1e3a-7299-8d34-7f6d5d87d5e6",
        "storage_key": "property/6767906449167606/01a01015-1e3a-7299-8d34-7f6d5d87d5e6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9191309365621035853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "optumrx-fulfillment",
      "poi_latitude": "38.9196071",
      "poi_longitude": "-94.6643722",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-45e7-740a-bf18-fe25147b3abd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc983-45e7-740a-bf18-fe25147b3abd",
        "storage_key": "property/6767906449167606/019fc983-45e7-740a-bf18-fe25147b3abd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSlrPD_qwIcRTROQnisXjn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_8c5aeb71-4eed-492d-a78d-a3f0709e27b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Overland Park City Hall",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8500 Santa Fe Dr, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc983-377f-72dd-99b2-e13f6230ae01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc983-377f-72dd-99b2-e13f6230ae01",
        "storage_key": "property/6767906449167606/019fc983-377f-72dd-99b2-e13f6230ae01.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/park/city-hall-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10640252352095117489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-city-hall",
      "poi_latitude": "38.97448380000001",
      "poi_longitude": "-94.6854831",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea5d-75d8-a18f-c8437d8d153e",
        "storage_key": "property/6767906449167606/019fc980-ea5d-75d8-a18f-c8437d8d153e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdh8t4HrwIcRseAkxyPFqZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2aaae188-6758-4737-960e-2ab6e1c0cc18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "Blue Valley Schools",
      "poi_type": "Education",
      "poi_address": "15020 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-21c6-7227-aaa2-1b7f2a48c3fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-21c6-7227-aaa2-1b7f2a48c3fc",
        "storage_key": "property/6767906449167606/01a01015-21c6-7227-aaa2-1b7f2a48c3fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.bluevalleyk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3950309088430247243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-schools",
      "poi_latitude": "38.8561923",
      "poi_longitude": "-94.6681349",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-239-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUbpZ95fqwIcRS83hsC9R0jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fcaab430-b572-417e-b4ce-4fe67ed44417",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "custom",
      "poi_name": "SMSD Center for Academic Achievement",
      "poi_type": "Education",
      "poi_address": "8200 W 71st St, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01015-21bb-735c-b1ca-315726d0d7d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01015-21bb-735c-b1ca-315726d0d7d6",
        "storage_key": "property/6767906449167606/01a01015-21bb-735c-b1ca-315726d0d7d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.smsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13529336476659713433&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smsd-center-for-academic-achievement",
      "poi_latitude": "39.0014907",
      "poi_longitude": "-94.6802101",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-993-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc980-ea0e-71f8-88a7-e919657f98d1",
        "storage_key": "property/6767906449167606/019fc980-ea0e-71f8-88a7-e919657f98d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF9r8VFzswIcRmYUJEtjbwbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d08ea83522af40e49506fc36",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ace4069f3976c93eaffe5eaf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_259bfc7f393052fe04bc55bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d033876acaaed56c325f2286",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d42e3908e8aea8616f1b5cec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_70fcbc457d8cdd369004321b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_0b7f30c3-1706-4993-b720-59f4d3471d0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "rating": "5",
      "name": "Nancy Lofland",
      "text": "Staff and maintenance are friendly and helpful.\nApartments are clean and fresh.\nCommunity is quiet!",
      "date": "2026-10-03",
      "title": "false"
    },
    {
      "id": "custom_5b128942-c16c-4907-b1ad-aa28ccff7053",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "rating": "4",
      "name": "Sam A",
      "text": "On the whole a pretty good, affordable place to live. Quiet, good location, maintenance is responsive and efficient, and in general just good vibes. The only points I can dock for are that the appliances are quite old, and the AC/heater quite loud. They work just fine, but worth noting. Id recommend\n",
      "date": "2026-10-01",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_f4e0569e223f11fb5a958232",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01031-49b7-738f-9084-84b98dd835b7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01031-49b7-738f-9084-84b98dd835b7",
        "storage_key": "property/6767906449167606/01a01031-49b7-738f-9084-84b98dd835b7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Aspen",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=991GMY6vxhL"
    },
    {
      "id": "ec_dcc441c974c40cadb289ec03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01031-4a64-7752-863c-777fe6319614.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01031-4a64-7752-863c-777fe6319614",
        "storage_key": "property/6767906449167606/01a01031-4a64-7752-863c-777fe6319614.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Spruce",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oguFR7or4xk"
    },
    {
      "id": "ec_bb28b588dbb383b487fd47a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01031-4ae0-754a-8300-c3d040c13abc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01031-4ae0-754a-8300-c3d040c13abc",
        "storage_key": "property/6767906449167606/01a01031-4ae0-754a-8300-c3d040c13abc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Birch",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=MFVYDRSXTrZ"
    },
    {
      "id": "ec_338b11daa893ff579f5e90d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167606/01a01031-4c0a-702c-9609-e4e6ce1fd4a7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01031-4c0a-702c-9609-e4e6ce1fd4a7",
        "storage_key": "property/6767906449167606/01a01031-4c0a-702c-9609-e4e6ce1fd4a7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cottage",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eFb4CWFBbKf"
    }
  ],
  "faqs": [
    {
      "id": "custom_2f867b06-f7ab-43c0-a094-dc35b09640d7",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_83671efc-b7db-4161-b87a-275ebe355aaf",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_9a06021f-6f38-4eb8-a379-985e36b25355",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_cea5477a-bc79-41fb-bcc0-28740a47f8d5",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d74be9ed-d54a-4dd6-a698-df4f4c665870",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_b02550fc-d04e-4dfc-8f76-1a19c21c7b06",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7cddf5d3-350b-41f7-af41-76832566618c",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_a4edbed7-0544-4116-8e30-84d2c514ddbd",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_c94da6d5-e1c6-454c-8d8d-e291a6ac30b7",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_96c82c68-84d3-4c90-8721-78e7ef384b4a",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_40ad996e-734e-48a5-85ec-1238d1cef842",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_6a6f06db-45e0-49f6-922a-e88e41753714",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_636867f8-145a-4e54-a3a6-e9cfcd58915e",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7443f5ae-1c11-478c-bdf8-9a2a48956634",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports. Please <a href=\"/contact-us\">contact the office</a> for our most current carport availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_c6cc0bfc-04b8-43ae-b6af-202c75fff573",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_8d2ea33c-5f98-4a7c-b448-e305020b9b67",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_0efbb07b-d8f8-486a-a43e-de4f59a8b4f7",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-3ba2-7551-aa03-08f198f22858",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Pebblebrook Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606"
    },
    {
      "lead_collector_id": "01a0c9ac-3c2e-7643-9a63-6c18d0b496b6",
      "lead_source": "LANDING_PAGE",
      "name": "Pebblebrook Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "in-home-washer-dryer-apartments-overland-park",
      "search_query": "apartments with in-home washer dryer Overland Park",
      "category": "Amenity",
      "h1_title": "In-Home Washer Dryer at Overland Park Apartments",
      "h2_subtitle": "Explore the comfort of apartments with in-home washer dryer amenities in Overland Park. Enjoy added convenience at Pebblebrook Apartment Homes.",
      "page_copy": "Discover the ultimate convenience of living in apartments with an in-home washer dryer in Overland Park at Pebblebrook Apartment Homes. Nestled in a tranquil corner of Central Overland Park, our one- and two-bedroom layouts offer the ideal retreat, providing essential comforts like laundry facilities right in your own unit. This ensures you experience an uninterrupted lifestyle amidst the serene greenery of our community.\n\nAt Pebblebrook, we go beyond mere convenience by offering a range of luxurious features, including a state-of-the-art fitness center, stainless appliance upgrades, and inviting outdoor grill areas. Enjoy discounts at local health clubs and engage in our planned social activities that connect you with the vibrant Overland Park community. Experience the blend of comfort and community at Pebblebrook Apartment Homes, where convenient amenities shape an extraordinary living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Home Washer Dryer at Overland Park Apts",
      "seo_description": "Discover Overland Park apartments with in-home washer dryer facilities at Pebblebrook. Enjoy added comfort in one and two-bedroom layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "luxury-apartments-central-air-johnson-county",
      "search_query": "luxury apartments with central air conditioning Johnson County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Central Air in Johnson Co.",
      "h2_subtitle": "Discover luxury apartments with central air conditioning in Johnson County. Experience premium living at Pebblebrook Apartment Homes.",
      "page_copy": "Indulge in the lavishness of luxury apartments with central air conditioning in Johnson County at Pebblebrook Apartment Homes. Our community offers elegantly designed one- and two-bedroom spaces that are equipped with state-of-the-art amenities, ensuring a comfortable and comprehensive living experience. Relish the soothing environment of Pebblebrook, perfectly tucked away in the greenery of Central Overland Park.\n\nWith features like a modern fitness center, fully upgraded stainless appliances, and a welcoming community atmosphere, Pebblebrook Apartment Homes invites you to a lifestyle of comfort and sophistication. Engage in planned social activities, enjoy grill facilities, and benefit from discounts at nearby health clubs. Elevate your living experience in a community that combines elegance with the convenience of central air conditioning, right in the heart of Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Central Air in Johnson Co.",
      "seo_description": "Explore luxury apartments in Johnson County with central air at Pebblebrook. Enjoy modern amenities and premium living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "pet-friendly-pool-apartments-pebblebrook",
      "search_query": "pet-friendly pool apartments Pebblebrook neighborhood",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Pool Apartments in Pebblebrook",
      "h2_subtitle": "Find pet-friendly pool apartments in the Pebblebrook neighborhood. Enjoy upscale living with your furry friends at Pebblebrook Apartment Homes.",
      "page_copy": "Welcome to Pebblebrook Apartment Homes, where finding pet-friendly pool apartments in the Pebblebrook neighborhood is a delight. Our community caters to both you and your pets, offering a welcoming environment with open outdoor spaces perfect for relaxation and play. Our spacious one- and two-bedroom layouts ensure that you and your furry companions have plenty of room to enjoy.\n\nAlongside our pet-accommodating features, our residents also benefit from a host of luxurious amenities. Dive into our refreshing pool on a sunny day or fire up the grill at our outdoor facilities. A state-of-the-art fitness center and planned social activities add more value to your lifestyle. Join our vibrant community in Central Overland Park and embrace a living experience that truly welcomes every member of your family, including the four-legged ones.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Pool Apartments in Pebblebrook",
      "seo_description": "Discover pet-friendly pool apartments in the Pebblebrook neighborhood. Perfect for you and your furry friends at Pebblebrook Apartment Homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartment-with-dishwasher-parking-overland-park",
      "search_query": "apartment with dishwasher and parking Overland Park KS",
      "category": "Amenity",
      "h1_title": "Apartment with Dishwasher & Parking in Overland Park",
      "h2_subtitle": "Discover apartments with dishwasher and parking amenities in Overland Park, KS. Pebblebrook offers comfort and convenience in a lush setting.",
      "page_copy": "Discover the convenience of an apartment with a dishwasher and parking in Overland Park, KS at Pebblebrook Apartment Homes. Our community is designed to offer a hassle-free lifestyle, providing spacious one- and two-bedroom layouts complete with modern conveniences such as a dishwasher in every unit and ample parking for you and your guests. Experience a seamless living experience amidst the lush surroundings of Central Overland Park.\n\nAt Pebblebrook, we prioritize not just convenience but also a rich community experience. Enjoy the benefits of a state-of-the-art fitness center, stainless appliances, and outdoor grilling facilities. Engage in our planned social activities or take advantage of discounts at local health clubs. Pebblebrook Apartment Homes is where comfort meets convenience, making it the perfect choice for a vibrant life in Overland Park, KS.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment with Dishwasher & Parking in Overland Park",
      "seo_description": "Find the ideal apartment with dishwasher and parking in Overland Park, KS at Pebblebrook. Enjoy modern amenities and a convenient lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "scenic-nature-trail-apartments-dog-park-overland-park",
      "search_query": "scenic nature trail apartments with dog park Overland Park",
      "category": "Amenity",
      "h1_title": "Scenic Nature Trail Apartments with Dog Park",
      "h2_subtitle": "Explore scenic nature trail apartments with a dog park in Overland Park. Live close to nature and enjoy quality time with your furry friends at Pebblebrook.",
      "page_copy": "Immerse yourself in the beauty of scenic nature trail apartments with a dog park in Overland Park at Pebblebrook Apartment Homes. Nestled amidst lush landscapes, our community offers one- and two-bedroom layouts, providing an ideal setting for nature enthusiasts and pet lovers alike. Explore scenic trails perfect for daily walks and adventures with your four-legged companions right on your doorstep.\n\nAlongside our scenic charm, Pebblebrook provides a wealth of community amenities. Relax at our pool, engage with neighbors through planned social activities, or keep in shape at our modern fitness center. Our dog park ensures that your pets have plenty of space to roam and play, making it the perfect place for both humans and pets to thrive. Experience a harmonious blend of nature and convenience in Central Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Scenic Nature Trail Apts with Dog Park in Overland Park",
      "seo_description": "Discover scenic nature trail apartments with a dog park in Overland Park at Pebblebrook. Perfect for nature lovers and their pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-overland-park-ks",
      "search_query": "one bedroom apartments overland park ks",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Overland Park, KS",
      "h2_subtitle": "Find ideal one bedroom apartments in Overland Park, KS. Pebblebrook Apartment Homes offers comfort and modern amenities in a sought-after location.",
      "page_copy": "Looking for one bedroom apartments in Overland Park, KS? Discover Pebblebrook Apartment Homes, where spacious one-bedroom layouts are paired with top-notch amenities for a fulfilling living experience. Our residences boast modern interiors, including stainless appliances, designed to make life both comfortable and convenient in the heart of Central Overland Park.\n\nAt Pebblebrook, enjoy more than just a place to live. Explore our beautiful surroundings, engage in planned social activities, and stay active with full access to our state-of-the-art fitness center. Whether you're grilling outdoors or enjoying health club discounts, our community enriches day-to-day life. Experience quintessential Overland Park living in our thoughtfully designed one-bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Overland Park, KS",
      "seo_description": "Explore one bedroom apartments in Overland Park, KS at Pebblebrook. Enjoy modern living near convenient amenities in Central Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "two-bedroom-rentals-johnson-county",
      "search_query": "two bedroom rentals in johnson county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Rentals in Johnson County",
      "h2_subtitle": "Explore two bedroom rentals in Johnson County at Pebblebrook. Enjoy spacious living with modern amenities in a prime location.",
      "page_copy": "Find the perfect two bedroom rentals in Johnson County at Pebblebrook Apartment Homes, where spaciousness meets functionality in every corner. Our two-bedroom apartments offer generous layouts filled with modern comforts, including in-home laundry and stainless appliances, ensuring your living experience is both practical and pleasant.\n\nLocated in a serene part of Central Overland Park, Pebblebrook provides not only a quality residence but an enriching community lifestyle. Take advantage of our state-of-the-art fitness center, enjoy outdoor relaxation with grills, and mingle with neighbors through planned social activities. With our ample storage solutions and pet-friendly environment, Pebblebrook truly enhances the experience of living in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Rentals in Johnson County",
      "seo_description": "Discover spacious two bedroom rentals in Johnson County at Pebblebrook. Enjoy modern amenities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-near-trailwood-elementary-overland-park",
      "search_query": "apartments near trailwood elementary overland park",
      "category": "School",
      "h1_title": "Apartments Near Trailwood Elementary",
      "h2_subtitle": "Discover family-friendly apartments near Trailwood Elementary in Overland Park. Pebblebrook offers convenience and comfort in a prime educational setting.",
      "page_copy": "For families seeking apartments near Trailwood Elementary in Overland Park, Pebblebrook Apartment Homes offers the ideal blend of location and lifestyle. With one- and two-bedroom layouts, our residences cater to varied needs, providing both comfort and functionality just minutes from a reputable school.\n\nPebblebrook not only places you near educational excellence but also enriches daily life with top-notch amenities. Benefit from a state-of-the-art fitness center, outdoor grilling spaces, and planned social activities that foster community spirit. Our pet-friendly environment, complete with a dog park, makes Pebblebrook a fitting place for family growth and enjoyment right in the heart of Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Trailwood Elementary, Overland Park",
      "seo_description": "Find family-friendly apartments near Trailwood Elementary at Pebblebrook. Enjoy a convenient and modern living experience in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "pebblebrook-apartments-near-brookridge-elementary",
      "search_query": "pebblebrook apartments by brookridge elementary",
      "category": "School",
      "h1_title": "Pebblebrook Apartments by Brookridge Elementary",
      "h2_subtitle": "Experience the convenience of living at Pebblebrook Apartments, located just minutes from Brookridge Elementary in Overland Park, KS.",
      "page_copy": "Situated perfectly by Brookridge Elementary, Pebblebrook Apartment Homes offers an ideal living environment for families seeking proximity to quality education in Overland Park. Our community features spacious one- and two-bedroom apartments equipped with modern conveniences like stainless appliances and in-home laundry, ensuring a comfortable lifestyle for you and your family.\n\nPebblebrook's amenities extend beyond your front door, with a state-of-the-art fitness center and organized social activities that bring neighbors together. Children will enjoy safe, peaceful surroundings, while parents appreciate the ease of nearby schools and community amenities. Choose Pebblebrook for a harmonious blend of home comforts and educational access near Brookridge Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pebblebrook Apartments: Near Brookridge Elementary",
      "seo_description": "Live near Brookridge Elementary at Pebblebrook Apartments. Perfect family-friendly apartments in Overland Park with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-near-john-diemer-elementary-school",
      "search_query": "apartments close to john diemer elementary school 66212",
      "category": "School",
      "h1_title": "Apartments Close to John Diemer Elementary",
      "h2_subtitle": "Explore Pebblebrook's apartments close to John Diemer Elementary School in the 66212 area. Perfect for families seeking convenience and comfort.",
      "page_copy": "Pebblebrook Apartment Homes offers an ideal location for families, with apartments close to John Diemer Elementary School in the 66212 ZIP code. Our community provides spacious one- and two-bedroom layouts that perfectly accommodate growing families, enriched by features such as in-home laundry and modern stainless appliances.\n\nLife at Pebblebrook extends beyond comfortable interiors, offering residents amenities like a Fitness Center and engaging social activities. Our serene setting and proximity to John Diemer Elementary make Pebblebrook a smart choice for families seeking educational convenience coupled with a welcoming community vibe in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near John Diemer Elementary School",
      "seo_description": "Find spacious apartments close to John Diemer Elementary School at Pebblebrook, offering a perfect blend of comfort and convenience in the 66212 area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-near-indian-woods-middle-school",
      "search_query": "apartments near indian woods middle school county",
      "category": "School",
      "h1_title": "Apartments Near Indian Woods Middle School",
      "h2_subtitle": "Discover Pebblebrook's apartments near Indian Woods Middle School, set in Johnson County, offering a family-friendly community environment.",
      "page_copy": "Located in the heart of Johnson County, Pebblebrook Apartment Homes provides an ideal setting for families with its proximity to Indian Woods Middle School. Our one- and two-bedroom apartments offer spacious living areas, modern stainless appliances, and convenient in-home laundry, ensuring both comfort and practicality.\n\nPebblebrook’s family-focused community features a state-of-the-art fitness center and outdoor grill spaces, perfect for socializing with neighbors. With planned social activities and a welcoming environment, living at Pebblebrook combines educational accessibility with a vibrant community spirit, making it a perfect choice near Indian Woods Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Indian Woods Middle School",
      "seo_description": "Live near Indian Woods Middle School at Pebblebrook, offering a family-friendly apartment community with modern amenities in Johnson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "shawnee-mission-west-high-school-nearby-apartments",
      "search_query": "shawnee mission west high school nearby apartments",
      "category": "School",
      "h1_title": "Nearby Apartments to Shawnee Mission West High",
      "h2_subtitle": "Find comfortable living at Pebblebrook, located near Shawnee Mission West High School, ideal for families in Overland Park, KS.",
      "page_copy": "Pebblebrook Apartment Homes offers an exceptional living experience with apartments located near Shawnee Mission West High School. Our community is perfect for families who desire proximity to this esteemed educational institution. You'll find one- and two-bedroom apartments designed with modern amenities such as in-home laundry and stainless steel appliances that enhance everyday convenience.\n\nThe serene environment at Pebblebrook is complemented by amenities like a state-of-the-art fitness center and planned social activities that promote a strong community feel. With its strategic location near Shawnee Mission West High School, Pebblebrook ensures both educational convenience and a warm, welcoming home environment in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Shawnee Mission West High School",
      "seo_description": "Discover Pebblebrook's family-friendly apartments near Shawnee Mission West High School, offering modern living and community-focused amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-near-shawnee-mission-south-high",
      "search_query": "apartments close to shawnee mission south high overland park",
      "category": "School",
      "h1_title": "Apartments Close to Shawnee Mission South High",
      "h2_subtitle": "Pebblebrook offers comfortable apartments close to Shawnee Mission South High in Overland Park. Ideal for families seeking a convenient location.",
      "page_copy": "Strategically located in Overland Park, Pebblebrook Apartment Homes provides spacious and modern one- and two-bedroom apartments close to Shawnee Mission South High School. Our residents enjoy premium features such as in-home laundry facilities and stainless steel appliances, designed for convenience and comfort.\n\nBeyond the interiors, Pebblebrook boasts amenities like a cutting-edge fitness center and outdoor social spaces with grills, perfect for family gatherings and neighborly connections. With planned social activities and its proximity to Shawnee Mission South High, Pebblebrook is perfect for families seeking a vibrant community and educational convenience in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Shawnee Mission South High",
      "seo_description": "Live near Shawnee Mission South High at Pebblebrook, Overland Park's prime choice for family-friendly apartments and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "holy-cross-catholic-school-apartments-pebblebrook",
      "search_query": "holy cross catholic school apartments pebblebrook",
      "category": "School",
      "h1_title": "Apartments Near Holy Cross Catholic School",
      "h2_subtitle": "Explore Pebblebrook's inviting apartments near Holy Cross Catholic School, offering easy access and community amenities in Overland Park.",
      "page_copy": "Pebblebrook Apartment Homes provides a perfect setting for families, offering stylish one- and two-bedroom apartments within close reach of Holy Cross Catholic School. Our well-appointed living spaces include features like in-home laundry and sleek stainless steel appliances that make everyday living a breeze.\n\nThe community at Pebblebrook is designed with family lifestyle in mind, offering a state-of-the-art fitness center and engaging outdoor spaces that foster social interaction. Residents enjoy planned social activities, promoting a warm sense of community while living near Holy Cross Catholic School in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pebblebrook Apartments Near Holy Cross Catholic School",
      "seo_description": "Discover the convenience of Pebblebrook Apartments near Holy Cross Catholic School, featuring modern amenities in a family-friendly Overland Park community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-near-johnson-county-community-college",
      "search_query": "apartments near johnson county community college",
      "category": "School",
      "h1_title": "Apartments Near Johnson County Community College",
      "h2_subtitle": "Pebblebrook offers convenient living near Johnson County Community College with inviting amenities in Overland Park, KS.",
      "page_copy": "Experience the perfect blend of comfort and convenience at Pebblebrook Apartment Homes, ideally situated near Johnson County Community College. Our community features modern one- and two-bedroom apartments equipped with in-home laundry and stainless steel appliances, providing a hassle-free lifestyle for students and professionals alike.\n\nResidents at Pebblebrook enjoy a vibrant community atmosphere, complete with a state-of-the-art fitness center and planned social activities that foster connections. The outdoor grilling area offers opportunities for relaxation and socializing. With its location near Johnson County Community College, Pebblebrook is a top choice for those seeking a balanced life in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson County Community College",
      "seo_description": "Find modern living at Pebblebrook, conveniently located near Johnson County Community College with great amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-near-shawnee-mission-early-childhood-center",
      "search_query": "apartments close to shawnee mission early childhood education center",
      "category": "School",
      "h1_title": "Apartments Close to Shawnee Mission Early Education",
      "h2_subtitle": "Discover Pebblebrook's family-friendly apartments close to Shawnee Mission Early Childhood Education Center offering ease and comfort in Overland Park.",
      "page_copy": "Pebblebrook Apartment Homes provides a welcoming environment for families seeking proximity to the Shawnee Mission Early Childhood Education Center. Our spacious one- and two-bedroom apartments are designed with convenience in mind, featuring in-home laundry and fully upgraded stainless steel appliances for a seamless living experience.\n\nThe community at Pebblebrook enhances family life with amenities such as a state-of-the-art fitness center and engaging outdoor spaces for relaxation and social gatherings. With planned social activities, residents can easily build connections while enjoying the benefits of nearby educational institutions like the Shawnee Mission Early Childhood Education Center in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Shawnee Mission Early Education",
      "seo_description": "Pebblebrook offers family-friendly living in Overland Park, near Shawnee Mission Early Childhood Education Center. Enjoy modern amenities and nearby convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-regional-medical-center",
      "search_query": "apartments near Overland Park Regional Medical Center KS",
      "category": "Hospital",
      "h1_title": "Apartments Near Overland Park Regional Medical Center",
      "h2_subtitle": "Pebblebrook offers convenient apartment living near Overland Park Regional Medical Center with top-notch amenities.",
      "page_copy": "Living at Pebblebrook Apartment Homes means having quick access to Overland Park Regional Medical Center, making it an ideal choice for healthcare professionals and patients alike. Our modern one- and two-bedroom layouts include in-home laundry facilities and upgraded stainless steel appliances, ensuring a comfortable and practical living experience.\n\nCommunal amenities at Pebblebrook enhance everyday life, featuring a state-of-the-art fitness center and planned social activities that build a vibrant community atmosphere. Located in the heart of Overland Park, residents enjoy the convenience of living near Overland Park Regional Medical Center along with the benefits of a cozy and friendly neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Overland Park Regional Medical Center",
      "seo_description": "Explore comfortable living at Pebblebrook, near Overland Park Regional Medical Center in KS, offering modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-arboretum",
      "search_query": "apartments near overland park arboretum & botanical gardens",
      "category": "Park",
      "h1_title": "Apartments Near Overland Park Arboretum & Gardens",
      "h2_subtitle": "Enjoy nature's beauty at Pebblebrook, ideally located near Overland Park Arboretum & Botanical Gardens.",
      "page_copy": "Pebblebrook Apartment Homes offers an enriching living experience near the natural tranquility of the Overland Park Arboretum & Botanical Gardens. Our one- and two-bedroom apartments are crafted with modern conveniences like in-home laundry and stainless steel appliances, perfect for those who value comfort and style.\n\nResidents relish the blend of peaceful surroundings and active lifestyle at Pebblebrook, featuring a state-of-the-art fitness center and planned social events. Living near the lush landscapes of the Overland Park Arboretum & Botanical Gardens allows you to immerse yourself in nature while still enjoying the vibrant community life within our unique Overland Park locale.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Overland Park Arboretum & Botanical Gardens",
      "seo_description": "Discover serene living at Pebblebrook, close to Overland Park Arboretum & Botanical Gardens, with upscale amenities in a natural setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "rentals-near-cherokee-park-overland-park",
      "search_query": "rentals close to cherokee park overland park",
      "category": "Park",
      "h1_title": "Rentals Close to Cherokee Park Overland Park",
      "h2_subtitle": "Discover comfortable rentals near Cherokee Park, offering modern amenities and a warm community atmosphere at Pebblebrook.",
      "page_copy": "At Pebblebrook Apartment Homes, we offer rentals conveniently located close to Cherokee Park in Overland Park, providing residents with easy access to both natural spaces and metropolitan conveniences. Our thoughtfully designed one- and two-bedroom apartments include luxurious features like in-home laundry and upgraded stainless steel appliances.\n\nThe Pebblebrook community enhances your lifestyle with a state-of-the-art fitness center and engaging social activities, creating a welcoming environment for all residents. Being just a short distance from Cherokee Park, you can enjoy scenic outdoor experiences while benefitting from the modern comforts provided at Pebblebrook Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Cherokee Park Overland Park",
      "seo_description": "Pebblebrook offers rentals near Cherokee Park in Overland Park, featuring modern amenities and easy access to natural and urban attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "pebblebrook-near-pinehurst-mischel-park",
      "search_query": "pebblebrook apartments by pinehurst mischel park",
      "category": "Park",
      "h1_title": "Pebblebrook Apartments by Pinehurst Mischel Park",
      "h2_subtitle": "Experience ideal living at Pebblebrook, perfectly situated near Pinehurst Mischel Park, offering modern amenities and a friendly community.",
      "page_copy": "Pebblebrook Apartment Homes, located near the serene Pinehurst Mischel Park, provides a unique blend of convenience and tranquility. Our one- and two-bedroom apartments come equipped with in-home laundry and sleek stainless steel appliances, aiming to offer residents comfort and modern living.\n\nAt Pebblebrook, enjoy access to a state-of-the-art fitness center and take part in planned social activities that foster community connections. Nestled in a prime location by Pinehurst Mischel Park, residents benefit from the proximity to peaceful green spaces while still being close to the vibrant offerings of Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pebblebrook Apts by Pinehurst Mischel Park",
      "seo_description": "Live at Pebblebrook near Pinehurst Mischel Park, featuring modern amenities and a welcoming community in a top Overland Park location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "overland-park-apartments-near-meadowbrook-park",
      "search_query": "overland park apartments near meadowbrook park",
      "category": "Park",
      "h1_title": "Overland Park Apartments Near Meadowbrook Park",
      "h2_subtitle": "Find your home at Pebblebrook, ideally located near Meadowbrook Park in Overland Park, with exceptional amenities and welcoming community spaces.",
      "page_copy": "Discover the comfort of Pebblebrook Apartment Homes, situated conveniently near Meadowbrook Park in Overland Park. Our one- and two-bedroom layouts offer attractive features such as in-home laundry and remarkable stainless steel appliances, designed to accommodate modern lifestyles.\n\nAt Pebblebrook, enjoy a robust community atmosphere with access to a state-of-the-art fitness center and various planned social activities. Life here combines urban convenience with natural beauty, allowing residents to relish the scenic trails and outdoor enjoyment Meadowbrook Park brings while living in the heart of Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Apts Near Meadowbrook Park",
      "seo_description": "Pebblebrook Apartments offer a prime Overland Park location near Meadowbrook Park, featuring modern living amenities and lush green surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-in-66212-near-foxhill-north-park",
      "search_query": "apartments in zip 66212 near foxhill north park",
      "category": "Park",
      "h1_title": "Apartments in 66212 Near Foxhill North Park",
      "h2_subtitle": "Pebblebrook offers ideal living in the 66212 zip code, close to Foxhill North Park, with modern amenities and a warm community.",
      "page_copy": "Experience exceptional living at Pebblebrook Apartment Homes, located in the desirable 66212 zip code, just a short distance from Foxhill North Park. Our thoughtfully designed one- and two-bedroom apartments feature modern conveniences like in-home laundry and fully upgraded stainless steel appliances, ensuring a comfortable lifestyle.\n\nResidents of Pebblebrook enjoy a vibrant community atmosphere, complete with a state-of-the-art fitness center and engaging social activities. Nestled near Foxhill North Park, our location provides the perfect blend of serene green spaces and easy access to the city amenities in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts in 66212 Near Foxhill North Park",
      "seo_description": "Live at Pebblebrook Apartments in zip 66212, near Foxhill North Park, and enjoy modern amenities in a welcoming Overland Park community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "johnson-county-rentals-near-nall-hills-park",
      "search_query": "johnson county rentals near nall hills park",
      "category": "Park",
      "h1_title": "Johnson County Rentals Near Nall Hills Park",
      "h2_subtitle": "Pebblebrook offers convenient rentals in Johnson County, ideally situated near Nall Hills Park, with contemporary amenities and a vibrant community.",
      "page_copy": "Discover comfortable living at Pebblebrook Apartment Homes, offering stunning rentals in Johnson County close to the lush Nall Hills Park. Our one- and two-bedroom apartment homes are thoughtfully equipped with in-home laundry facilities and modern stainless steel appliances, catering to your contemporary lifestyle needs.\n\nPebblebrook residents enjoy superior community features, including a state-of-the-art fitness center and lively planned social events. Positioned conveniently near Nall Hills Park, our community provides the perfect blend of natural beauty and urban convenience, making it an ideal choice for those seeking rentals in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Johnson County Rentals by Nall Hills Park",
      "seo_description": "Pebblebrook offers rentals in Johnson County near Nall Hills Park, providing modern amenities and a vibrant community experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-near-nall-park-overland-park",
      "search_query": "apartments near nall park overland park",
      "category": "Park",
      "h1_title": "Apartments Near Nall Park, Overland Park",
      "h2_subtitle": "Find your perfect home at Pebblebrook, located near Nall Park in Overland Park, offering modern amenities and a relaxed lifestyle.",
      "page_copy": "Live comfortably at Pebblebrook Apartment Homes, conveniently located near Nall Park in Overland Park. Our spacious one- and two-bedroom apartments come complete with in-home laundry and upgraded stainless steel appliances, offering a seamless living experience.\n\nEnjoy an active lifestyle with our state-of-the-art fitness center and engage in a variety of planned social activities within our welcoming community. Pebblebrook combines the tranquility of being near Nall Park with the vibrant atmosphere of Overland Park, making it the perfect place for both relaxation and urban convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Nall Park in Overland Park",
      "seo_description": "Pebblebrook Apartments provide easy access to Nall Park in Overland Park with excellent amenities and a warm community vibe.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-in-overland-park-near-roe-park",
      "search_query": "apartments in overland park near roe park",
      "category": "Park",
      "h1_title": "Apartments in Overland Park Near Roe Park",
      "h2_subtitle": "Pebblebrook offers stylish apartments in Overland Park, nestled conveniently near Roe Park, with a range of modern amenities and community activities.",
      "page_copy": "Explore the inviting lifestyle at Pebblebrook Apartment Homes, ideally situated near Roe Park in Overland Park. Our beautifully designed one- and two-bedroom apartments boast features such as in-home laundry and upgraded stainless appliances, enhancing your everyday comfort.\n\nReside in a vibrant community with a state-of-the-art fitness center and regular social gatherings designed to foster a sense of belonging. Located near Roe Park, Pebblebrook seamlessly blends the tranquility of lush surroundings with the dynamic offerings of Overland Park, making it a top choice for those seeking urban living with a natural touch.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts in Overland Park Close to Roe Park",
      "seo_description": "Enjoy modern living at Pebblebrook Apartments in Overland Park, just steps from Roe Park, with upscale amenities and a welcoming community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "near-regency-lake-park-overland-park-apartments",
      "search_query": "near regency lake park overland park apartments",
      "category": "Park",
      "h1_title": "Near Regency Lake Park Overland Park Apartments",
      "h2_subtitle": "Discover comfortable living at Pebblebrook, located near Regency Lake Park in Overland Park. Enjoy modern amenities and a serene setting.",
      "page_copy": "Pebblebrook Apartment Homes invites you to experience convenient living near Regency Lake Park in the heart of Overland Park. Our spacious one- and two-bedroom floor plans are equipped with essential features like in-home laundry and sleek stainless steel appliances, all designed to complement a relaxed lifestyle.\n\nJoin a welcoming community that offers a state-of-the-art fitness center and engaging planned social activities. Nestled close to the beautiful Regency Lake Park, Pebblebrook combines serene park views with the vibrant energy of Overland Park, providing an ideal setting for any lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts by Regency Lake Park in Overland Park",
      "seo_description": "Enjoy modern living at Pebblebrook Apartments near Regency Lake Park in Overland Park, with great amenities and a close-knit community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "rentals-close-to-overland-park-city-hall",
      "search_query": "rentals close to overland park city hall",
      "category": "Park",
      "h1_title": "Rentals Close to Overland Park City Hall",
      "h2_subtitle": "Pebblebrook Apartments offer stylish living just minutes from Overland Park City Hall, with convenient amenities and community charm.",
      "page_copy": "At Pebblebrook Apartment Homes, you're just a short distance from Overland Park City Hall, allowing you to enjoy the convenience of city living. Our well-designed one- and two-bedroom rentals provide everything you need, from in-home laundry facilities to upgraded stainless steel appliances, ensuring a comfortable and modern lifestyle.\n\nTake advantage of our vibrant community life, featuring a state-of-the-art fitness center and social events that foster connections among neighbors. Positioned conveniently close to the hustle and bustle of Overland Park City Hall, Pebblebrook offers the perfect blend of urban accessibility and homely warmth.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Overland Park City Hall",
      "seo_description": "Discover Pebblebrook Apartments, ideally located near Overland Park City Hall, with modern amenities and a community-focused environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167606",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport-overland-park",
      "search_query": "apartments near kansas city international airport overland park",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Pebblebrook Apartments offer a comfortable stay in Overland Park, conveniently located near Kansas City International Airport.",
      "page_copy": "Located in the heart of Overland Park, Pebblebrook Apartment Homes perfectly position you near Kansas City International Airport. Our one- and two-bedroom apartments are designed with modern living in mind, featuring in-home laundry facilities and sleek stainless steel appliances.\n\nThe community at Pebblebrook goes beyond just living spaces, offering a state-of-the-art fitness center and vibrant social activities that create a welcoming environment. With easy access to Kansas City International Airport, Pebblebrook Apartments ensure you are well-connected while enjoying the serenity of Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019fc981-33dd-77a1-bcbe-0ef96dea8f24",
        "storage_key": "property/6767906449167606/019fc981-33dd-77a1-bcbe-0ef96dea8f24.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near KC International Airport",
      "seo_description": "Pebblebrook Apartments in Overland Park are convenient to Kansas City International Airport, providing modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701854593"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N27VPNJZ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 7"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/277c3e39-b592-477f-b89d-db87d901c1cc/app.js?nocache=1&gaTracking=G-N9V96ECW7B&buttonbgcolor=002e5d&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-704-6244"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ikh1bVJPdnZtbTZ5WmxjY0EzUlJOVGc9PSIsInZhbHVlIjoicjNhQ0wyRlBUZDBFeHc0eVhLMW0wZz09IiwibWFjIjoiMmRlNjJiZDFhYTAyNTU1ZGU3YzhkYWVmODlkYmY3MDAyZjhhNjIwNTdlYzQ4NzJmNDg5ZTZjOGEwOGEwODk0MCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701854593",
  "custom_google_gtm_id": "GTM-N27VPNJZ",
  "custom_rollout_phase": "Batch 7",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/277c3e39-b592-477f-b89d-db87d901c1cc/app.js?nocache=1&gaTracking=G-N9V96ECW7B&buttonbgcolor=002e5d&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-704-6244",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ikh1bVJPdnZtbTZ5WmxjY0EzUlJOVGc9PSIsInZhbHVlIjoicjNhQ0wyRlBUZDBFeHc0eVhLMW0wZz09IiwibWFjIjoiMmRlNjJiZDFhYTAyNTU1ZGU3YzhkYWVmODlkYmY3MDAyZjhhNjIwNTdlYzQ4NzJmNDg5ZTZjOGEwOGEwODk0MCJ9",
  "custom_audioeye_site_id": "12239174-598e-4325-8783-3eb5283b57a5",
  "custom_audioeye_site_hash": "cdce0ecaec589040000fb228a0de4529"
};

export const generatedAt = '2026-11-03T22:57:41.371Z';
